{
  "unavailable": {
    "requestTitle": "Request unavailable",
    "requestDescription": "This request is no longer available. It may have been deleted or the link may be incorrect.",
    "requestAction": "Go to my requests",
    "budgetTitle": "Quote unavailable",
    "budgetDescription": "This quote is no longer available. It may have been deleted or the link may be incorrect.",
    "budgetAction": "Go to quotes"
  },
  "identityCandidates": {
    "title": "Alternatives suggested by Atlas",
    "choose": "Select this product",
    "searchLabel": "Code, reference, brand or visible text",
    "search": "Search with Atlas",
    "reviewPending": "Atlas could not identify the product from what it read in the document. The code, reference, brand or description must be corrected as they appear in the document.",
    "pendingTitle": "Identification in progress",
    "identityPending": "Atlas has not yet published the next step to identify this product.",
    "readValues": "What Atlas read in the document:",
    "askAgainHint": "Ask Atlas again to open the form and continue.",
    "askAgain": "Ask Atlas again",
    "correctTitle": "Correct the reading",
    "correctHint": "Correct only data visible in the document. Atlas will search again without changing quantity or unit.",
    "confirmCorrection": "Confirm correction",
    "fields": {
      "source_code": "Read code",
      "source_reference": "Read reference",
      "source_brand": "Read brand",
      "source_description": "Read description",
      "raw_text": "Full read text"
    },
    "selecting": "Selecting…"
  },
  "documentQuantity": {
    "commercialPending": "Sales review of the purchase unit",
    "commercialHint": "The sales team will confirm how these products are bought: {{products}}. You do not need to do anything: you can continue and they will be sent flagged for that review.",
    "pending": "Confirm the pending quantities before continuing. Other products do not need this review.",
    "review": "Review quantity",
    "missing": "Quantity pending"
  },
  "admin": {
    "atlasSkills": {
      "title": "Atlas status and readers",
      "refresh": "Check",
      "hint": "API data, Portal reading evidence and the skill inventory are checked separately.",
      "installedVersion": "Installed",
      "activeVersion": "Active in Atlas",
      "latestVersion": "Latest reported by Atlas",
      "channel": "Available channel",
      "unknownValue": "Unconfirmed",
      "checked": "Last check: {{date}}",
      "observed": "Atlas inventory: {{date}}",
      "empty": "Atlas has confirmed an empty inventory.",
      "noVisibleSkills": "There are no skills to display in this Portal section.",
      "unsupported": "Atlas does not yet publish its skill versions through the API.",
      "not_configured": "Configure and enable the Atlas connection to check its skills.",
      "unauthorized": "Atlas did not authorize this query. Check the API connection.",
      "unavailable": "Could not reach Atlas. You can check again.",
      "invalid_response": "Atlas did not return a valid inventory. Unconfirmed versions are not displayed.",
      "states": {
        "current": "Up to date",
        "update_available": "Update available",
        "development": "In development",
        "inactive": "Inactive",
        "unknown": "Unconfirmed"
      },
      "channels": {
        "stable": "Stable",
        "development": "Development",
        "unknown": "Unconfirmed"
      },
      "runtimeTitle": "Atlas API",
      "apiVersion": "Declared API version",
      "apiRelease": "Release",
      "recognitionSchema": "Recognition contract",
      "documentContract": "Document contract",
      "runtimeMismatch": "The loaded code fingerprint differs from the release declared by Atlas. This release cannot be confirmed as running.",
      "runtimeUnavailable": "Atlas has not confirmed its API version in this check.",
      "readerTitle": "Last observed document reader",
      "readerLean": "Lean: explicit evidence exists in the last saved document reading.",
      "readerNotObserved": "No verifiable evidence identifies the document reader.",
      "readerVersion": "Reader version",
      "readerVersionUnknown": "No confirmed version in this check",
      "readerObservedAt": "Observed reading result: {{date}} (Spain time)",
      "readerObservationHint": "This evidence belongs to a saved Portal result. It does not confirm the current service configuration or replace a version published by Atlas.",
      "skillsTitle": "Skill inventory",
      "skillsHint": "Versions reported by Atlas. A photo skill alone does not identify the PDF or Excel reader.",
      "versionConflictLabel": "Check inventory",
      "versionConflictHint": "Atlas reports a latest version older than the installed or active version. Its values are preserved, but the skill cannot be confirmed as up to date."
    },
    "approve": "Approve",
    "approveConfirmText": "The company and the user will be created, and they'll be able to sign in straight away.",
    "approveConfirmTitle": "Approve this sign-up?",
    "approved": "Sign-up approved",
    "assistantOff": "Disabled",
    "assistantOn": "Active",
    "assistantReachable": "Service reachable",
    "assistantSection": "Atlas Assistant",
    "assistantToggle": "Show the assistant to clients",
    "assistantToggleHint": "Turning it off removes it from the menu and the portal stops accepting queries. The service keeps running, so you can switch it back on at any time.",
    "assistantUnreachable": "Service unreachable",
    "assistantAnalyticsTitle": "What customers ask Atlas",
    "assistantAnalyticsSubtitle": "Accumulated query history to identify needs and products that require more help.",
    "assistantAnalyticsAnonymous": "Aggregated data",
    "assistantAnalyticsQuestions": "Questions asked",
    "assistantAnalyticsChats": "Chats started",
    "assistantAnalyticsCoverage": "Queries linked to products",
    "assistantAnalyticsTopProducts": "Products causing the most questions",
    "assistantAnalyticsTopProductsHint": "Products identified and validated by Atlas in its answers.",
    "assistantAnalyticsQuestionTypes": "What people ask",
    "assistantAnalyticsQuestionTypesHint": "Primary reason for each query, grouped by intent.",
    "assistantAnalyticsTopics": "Most frequent topics",
    "assistantAnalyticsTopicsHint": "Technical areas that appear most often.",
    "assistantAnalyticsTimeline": "Daily activity",
    "assistantAnalyticsTimelineHint": "Queries and conversations during the retained period.",
    "assistantAnalyticsTimelineValue": "{{questions}} queries · {{sessions}} chats",
    "assistantAnalyticsEmpty": "There are not enough queries to show this ranking yet.",
    "assistantAnalyticsPrivacyTitle": "Privacy by design",
    "assistantAnalyticsPrivacyText": "This view receives no names, email addresses or full conversation text. It only shows aggregated counts.",
    "auditAction": "Action",
    "auditEmpty": "No activity recorded",
    "auditEmptyText": "Everything that happens in the portal is collected here.",
    "auditEntity": "Item",
    "auditWho": "Who",
    "budgetActions": "Quote actions",
    "budgetCompany": "Company",
    "budgetValidUntil": "Valid until",
    "budgetsEmpty": "No quotes match what you are looking for.",
    "budgetsHint": "All quotes created through the Portal, with their author and creation date.",
    "budgetsSearch": "Search by reference or project",
    "budgetsTitle": "Portal quotes",
    "colApplicant": "Applicant",
    "colCompany": "Company",
    "colOrigin": "Origin",
    "colWaiting": "Requested",
    "extend": "Extend validity",
    "extendDone": "Validity extended.",
    "extendField": "New expiry date",
    "extendText": "Choose how long “{{ref}}” stays valid. The client will be notified.",
    "extendTitle": "Extend the validity",
    "hermesApiKey": "API key",
    "hermesApiKeyHint": "Sent to Atlas to identify the portal.",
    "hermesAutoSubmit": "Send the job when the request is submitted",
    "hermesAutoSubmitHint": "When off, Adaltra sends the job by hand.",
    "hermesAutoSubmitNeedsSecret": "Needs the signing secret: without it, Atlas's reply cannot be verified.",
    "hermesBaseUrl": "API address",
    "hermesCallbackSecret": "Signing secret",
    "hermesCallbackSecretHint": "Atlas signs its replies with it. Not the API key.",
    "hermesCallbackUrl": "Atlas must reply to",
    "hermesClear": "Clear",
    "hermesEnabled": "Integration active",
    "hermesEnabledHint": "When off, the portal neither sends jobs nor accepts replies.",
    "hermesHint": "Atlas drafts quotes from submitted requests and creates them in Ada-quote, where a sales rep reviews them.",
    "hermesSaved": "Connection saved.",
    "hermesSecretPlaceholder": "Type to replace it",
    "hermesSecretSet": "Saved",
    "hermesSecretUnset": "Not set",
    "hermesTest": "Test connection",
    "hermesTestFail": {
      "missingBaseUrl": "The API address is missing.",
      "missingApiKey": "The API key is missing.",
      "unauthorized": "Atlas rejects the key.",
      "badStatus": "Atlas responds, but with an error ({{status}}).",
      "timeout": "Atlas did not reply in time.",
      "unreachable": "Could not connect to that address."
    },
    "hermesTestOk": "Atlas responds correctly.",
    "hermesTesting": "Testing…",
    "hermesTimeout": "Timeout (ms)",
    "hermesTitle": "Atlas agent",
    "onlyStaff": "This area is for Adaltra staff only.",
    "registrationsEmpty": "No pending sign-ups",
    "registrationsEmptyText": "New client access requests will appear here.",
    "reject": "Reject",
    "rejectConfirmText": "The request will be marked as rejected and no account will be created.",
    "rejectConfirmTitle": "Reject this sign-up?",
    "rejected": "Sign-up rejected",
    "remind": "Resend the notice",
    "remindDone": "Notice resent to the client.",
    "sectionNav": "Admin sections",
    "settingsSaved": "Settings saved",
    "notificationsSaved": "Notification settings saved.",
    "notificationChannelsTitle": "Channels for general alerts",
    "notificationChannelsHint": "Choose how clients receive alerts generated by the portal.",
    "pushBroadcastTitle": "Send a push notification",
    "pushBroadcastHint": "Write a short alert for everyone who enabled notifications on a device.",
    "pushBroadcastModalHint": "It will be sent to {{count}} subscribed devices. Review the content before confirming.",
    "composePush": "Compose notification",
    "registeredUsers": "Registered users",
    "pushSubscribedUsers": "Push enabled",
    "pushConfigureBeforeSend": "Configure and enable the push keys before sending an alert.",
    "pushMessageTitle": "Notification title",
    "pushMessageBody": "Message",
    "sendPushNow": "Send notification",
    "pushBroadcastSent": "Notification sent to {{count}} devices.",
    "emailChannelTitle": "General alerts by email",
    "emailChannelHint": "Separately control whether automatic portal alerts are also sent by email.",
    "channelPortal": "Portal and bell",
    "channelPortalHint": "Stores the alert in the notification centre.",
    "channelEmail": "Email",
    "channelEmailHint": "Sends a copy through the SMTP server.",
    "channelPush": "Push notification",
    "channelPushHint": "Shows the alert on the device even when Atlas is closed.",
    "smtpTitle": "SMTP mail server",
    "smtpHint": "Configure the server used for portal alerts and transactional email.",
    "smtpUrl": "SMTP URL (optional)",
    "smtpUrlHint": "When provided, it replaces the separate server and port.",
    "smtpUrlConfigured": "A protected SMTP URL is configured. It will be kept unless you enter a different server.",
    "smtpHost": "Server",
    "smtpPort": "Port",
    "smtpSecure": "Use direct secure connection (TLS)",
    "smtpUser": "User",
    "smtpPassword": "Password",
    "smtpPasswordHint": "Leave blank to keep the saved password.",
    "smtpFrom": "Sender",
    "smtpReplyTo": "Reply to (optional)",
    "smtpEnabled": "Enable email delivery",
    "smtpTestSent": "Test email sent to {{email}}.",
    "pushTitle": "Push notifications",
    "pushHint": "Configure the stable VAPID keys Atlas uses to identify this server to browsers.",
    "pushPublicKey": "VAPID public key",
    "pushPrivateKey": "VAPID private key",
    "pushPrivateKeyHint": "It is never displayed again. Leave blank to keep it.",
    "pushSubject": "Service contact",
    "pushSubjectHint": "Usually an address such as mailto:support@example.com.",
    "pushEnabled": "Enable push notifications",
    "generateVapid": "Generate keys",
    "sendTest": "Send test",
    "pushTestSent": "Test notification sent to this device.",
    "pushTestNoSubscription": "The configuration works, but this user has no subscribed device yet.",
    "configurationFromEnvironment": "This configuration currently comes from the server environment. Saving it here will move its management to Administration.",
    "statActiveUsers": "Active users",
    "statOpenTickets": "Open tickets",
    "statPendingRegistrations": "Pending sign-ups",
    "subtitle": "Client registrations, quotes, support and portal settings.",
    "tabAudit": "Audit",
    "tabAssistantAnalytics": "Atlas analytics",
    "tabBudgets": "Quotes",
    "tabRegistrations": "Sign-ups",
    "tabSettings": "Settings",
    "tabNotifications": "Notifications",
    "tabEmail": "Email",
    "tabTickets": "Support",
    "tabUsers": "Users",
    "tabReleases": "Updates",
    "releasesTitle": "Platform updates",
    "releasesDescription": "Published changes for Sales and Managers.",
    "releaseNew": "New release",
    "releasesEmpty": "No releases yet",
    "releasesEmptyText": "Published updates will appear here.",
    "releaseStatus": {
      "draft": "Draft",
      "published": "Published"
    },
    "releaseLinkedCount": "{{count}} linked requests",
    "releaseIncludesYours": "Includes one of your requests",
    "releaseEdit": "Edit release",
    "releaseVersion": "Version",
    "releaseTitle": "Title",
    "releaseSummary": "Summary",
    "releaseChanges": "Changes",
    "releaseChangesHelp": "Enter one change per line.",
    "releaseLinkedRequests": "Linked requests",
    "releaseLinkedRequestsHelp": "Publishing completes all linked requests.",
    "releaseSaved": "Release saved.",
    "platformRequestTitle": "Suggest an improvement",
    "platformRequestAction": "Suggest an improvement or change",
    "platformRequestDescription": "Tell us what should be added or improved in the platform.",
    "platformRequestSubject": "Request title",
    "platformRequestDetails": "Description",
    "platformRequestSend": "Send request",
    "platformRequestSent": "Request sent.",
    "platformRequestsAll": "Employee requests",
    "platformRequestsMine": "My requests",
    "platformRequestsAllText": "Review, plan and link suggestions to a release.",
    "platformRequestsMineText": "Track each suggestion and the version that includes it.",
    "platformRequestsEmpty": "No requests",
    "platformRequestsEmptyText": "New suggestions will appear here.",
    "platformRequestStatus": {
      "new": "New",
      "under_review": "Under review",
      "planned": "Planned",
      "declined": "Declined",
      "completed": "Completed"
    },
    "platformRequestAdminNote": "Administrator note",
    "platformRequestIncluded": "Included in v{{version}}",
    "platformRequestReview": "Review request",
    "platformRequestSaved": "Request updated.",
    "usersTitle": "User management",
    "usersHint": "Manage portal access and the commercial link for each account.",
    "usersCount": "{{count}} users",
    "searchUsers": "Search users",
    "user": "User",
    "userRole": "Role",
    "userRole_client": "Client",
    "userRole_commercial": "Sales",
    "userRole_manager": "Manager",
    "userRole_admin": "Administrator",
    "rolesAdminOnly": "Only an administrator can change roles.",
    "emailBroadcastTitle": "Send a general email",
    "emailBroadcastHint": "Send the same message by blind copy to every active user with the selected role.",
    "emailAudienceRole": "Recipients",
    "emailSubject": "Subject",
    "emailBody": "Message",
    "addAttachments": "Add attachments",
    "noAttachments": "No attachments · up to 5 files of 10 MB",
    "sendEmailNow": "Send email",
    "sendingEmail": "Sending…",
    "emailBroadcastSent": "Email sent to {{count}} recipients with {{attachments}} attachments.",
    "userStatus_pending": "Pending",
    "userStatus_active": "Active",
    "userStatus_blocked": "Blocked",
    "customerCode": "Customer code",
    "generatedBudgets": "Requests and quotes",
    "viewUserRequests": "View every request from this user",
    "userRequestsTitle": "Requests from {{name}}",
    "userRequestsHint": "Includes drafts, document reviews and generated quotes. You can continue, reanalyze and manage the user’s requests.",
    "userRequestsEmpty": "This user has not created any requests yet.",
    "userRequestItems": "{{count}} items",
    "userRequestCreated": "Created",
    "userRequestFiles": "Files",
    "userRequestBudget": "Quote",
    "userRequestBudgetPending": "Not generated yet",
    "userRequestMaterials": "Materials list",
    "userRequestMaterialsPending": "The materials list is not available at this stage yet.",
    "assistantAnalyticsRecentQuestions": "Recent questions",
    "assistantAnalyticsRecentQuestionsHint": "Questions sent to the assistant, together with the account that asked them.",
    "assistantAnalyticsUnknownUser": "User unavailable",
    "lastAccess": "Last access",
    "neverAccessed": "Never",
    "editUser": "Edit user",
    "adaQuoteCustomerCodeAdminHint": "AdaQuote code for this company or branch. It applies to its Client accounts; other branches can share it without being changed.",
    "editCustomerCode": "Edit customer code",
    "editCustomerCodeFor": "Edit customer code for {{name}}",
    "staffCustomerCodeHint": "The administrator can assign this account its own code. Without one, it uses 0.",
    "staffPersonalCustomerCodeHint": "This user’s own code for submitting and retrieving quotes. The company and other users are not affected. Leave blank to use 0.",
    "personalCustomerCodeHint": "This administrator’s own code for submitting and retrieving quotes. Other users are not affected. Leave blank to use 0.",
    "userSaved": "User updated.",
    "ticketClosed": "Closed",
    "ticketInProgress": "In progress",
    "ticketOpen": "Open",
    "ticketsEmpty": "No tickets",
    "ticketsEmptyText": "Client support enquiries will appear here.",
    "title": "Administration",
    "withdraw": "Withdraw the offer",
    "withdrawDone": "Quote withdrawn.",
    "withdrawText": "“{{ref}}” will be marked as expired and the client will not be able to accept it. They will be notified.",
    "withdrawTitle": "Withdraw this quote?",
    "adaQuoteTitle": "Ada-quote",
    "adaQuoteHint": "Optional direct connection for synchronizing quotes. Stock and PDFs also have their own query through Atlas.",
    "adaQuoteBaseUrl": "API address",
    "adaQuoteApiKey": "API key",
    "adaQuoteApiKeyHint": "Sent to Ada-quote to identify the portal.",
    "adaQuoteEnabled": "Connection active",
    "adaQuoteEnabledHint": "When off, direct Ada-quote synchronization is skipped. The Atlas connection stays enabled.",
    "adaQuoteSaved": "Connection saved.",
    "adaQuoteTestOk": "Ada-quote responds correctly.",
    "adaQuoteTestNoHealth": "Ada-quote responds and accepts the key, though it has no status page.",
    "adaQuoteTestFail": {
      "missingBaseUrl": "The API address is missing.",
      "missingApiKey": "The API key is missing.",
      "unauthorized": "Ada-quote rejects the key.",
      "badStatus": "Ada-quote responds, but with an error ({{status}}).",
      "timeout": "Ada-quote did not reply in time.",
      "unreachable": "Could not connect to the Ada-quote address."
    },
    "adaQuoteScope": "Each client sees only their own quotes: the portal uses the AdaQuote customer code stored on the session company, never one sent by the browser.",
    "connectionChecking": "Checking…",
    "connectionKeyNotVerified": "It responds, but we could not verify the key.",
    "modules": {
      "title": "Modules",
      "checking": "Checking each module…",
      "summary": "{{active}} of {{total}} active",
      "withIssues": "{{count}} with issues",
      "refresh": "Check now",
      "version": "Version {{version}}",
      "versionUnknown": "Version not available",
      "configure": "Configure",
      "tools": "Tools",
      "serverSwitch": "Enabled on the server",
      "state": {
        "on": "Active",
        "off": "Off",
        "error": "Error",
        "warning": "Out of date",
        "checking": "Checking…"
      },
      "atlas": {
        "title": "Atlas · reading API",
        "text": "Reads request documents, identifies products and prepares quotes."
      },
      "adaQuote": {
        "title": "Ada-quote",
        "text": "Prices, discounts, stock and quotes in the ERP."
      },
      "customers": {
        "title": "Customer master",
        "text": "Ada customers and delivery addresses, to assign a customer and place orders.",
        "detail": "{{count}} customers · version {{version}} · checked {{date}}",
        "stale": "Not updated since {{date}}",
        "unavailable": "Atlas is not responding"
      },
      "catalog": {
        "title": "Product catalogue",
        "text": "Copy of the product Master published by Atlas, used to search and validate references.",
        "detail": "{{count}} products · version {{version}} · {{date}}"
      },
      "assistant": {
        "text": "Atlas help chat for staff and customers."
      }
    },
    "notifConfig": {
      "pushTitle": "Notification settings",
      "pushHint": "Web Push and the channels portal notices are delivered through.",
      "emailTitle": "Email settings",
      "emailHint": "Mail server (SMTP) and email notices.",
      "sender": "Sender",
      "notConfigured": "Not configured"
    },
    "connection": {
      "connected": "Connected",
      "error": "Error",
      "disconnected": "Disconnected"
    },
    "direccion": {
      "interna": "This address only exists inside the local network. The portal reaches it from here, but it will stop working once the portal is deployed elsewhere. That needs a tunnel or a public address.",
      "sinCifrar": "Unencrypted address (http). The API key travels in a header, so outside your own network you should use https.",
      "malformada": "This address does not look valid. It must start with https:// or http://."
    },
    "catalogSync": "Copy catalogue",
    "catalogSyncing": "Copying…",
    "catalogSynced": "Catalogue copied: {{count}} items ({{deactivated}} withdrawn).",
    "catalogAlreadyCurrent": "The copy is already up to date: {{count}} items.",
    "approvedEmailUnavailable": "Account approved. The notification email could not be sent to the customer.",
    "requestSendToAtlas": "Send to Atlas",
    "requestSendConfirm": "You will send {{ref}}, with {{count}} lines, to Atlas to create the AdaQuote quote for {{name}}. The owner’s details and customer code will be used.",
    "requestReviewWithAtlas": "Review with Atlas",
    "requestDiscardSuggestion": "Do not add",
    "requestRecovered": "List recovered from {{ref}}. Complete the review before sending.",
    "requestAlreadySent": "This job has already been sent to Atlas or has a linked quote.",
    "requestNeedsReview": "The list must complete its review before sending.",
    "requestContinue": "Continue request",
    "requestOpen": "Open request",
    "requestReanalyze": "Analyze again",
    "requestDelete": "Delete request",
    "requestCancel": "Cancel request",
    "requestRestore": "Restore request",
    "requestBackToUsers": "Back to users",
    "requestActingFor": "Managing the request of {{name}} · {{company}}",
    "requestExistingOnly": "Continue this request or return to Administration to select another.",
    "requestActionTitle_reanalyze": "Analyze documents again",
    "requestActionTitle_delete": "Delete request",
    "requestActionTitle_cancel": "Cancel request",
    "requestActionConfirm_reanalyze": "Analyze the documents of {{ref}}, owned by {{name}}, again? The list will be reviewed again and results must be confirmed before submission.",
    "requestActionConfirm_delete": "Permanently delete {{ref}}, owned by {{name}}, and its files? This cannot be undone.",
    "requestActionConfirm_cancel": "Cancel {{ref}}, owned by {{name}}? You can then restore or permanently delete it from Administration.",
    "requestBudgetReadOnly": "Administrative quote view. Acceptance and rejection remain with the customer.",
    "userRole_orders": "Orders",
    "deleteUserDescription": "Access will be revoked and the user will disappear from this list. Their requests, quotes and audit history will be retained.",
    "passwordChangePending": "Password change required",
    "forcePasswordResetDescription": "An email will contain a one-hour link to enter and repeat a new password. After sending, their sessions will end and they must change their password to sign in again.",
    "ownPasswordAction": "Change your password from your profile",
    "deletingUser": "Deleting…",
    "sendingPasswordReset": "Sending…",
    "userDeleted": "User deleted. Their requests and quotes have been retained.",
    "deleteUser": "Delete user",
    "sendPasswordReset": "Send email",
    "cannotDeleteSelf": "You cannot delete your own account",
    "forcePasswordResetFor": "Require {{name}} to change their password",
    "passwordResetSent": "Email sent. The user must change their password to sign in again.",
    "forcePasswordReset": "Require password change",
    "deleteUserFor": "Delete {{name}}",
    "budgetCreatedBy": "Created by",
    "budgetCreatedAt": "Created on",
    "budgetsPerPage": "Quotes per page",
    "budgetPageRange": "{{from}}–{{to}} of {{count}}"
  },
  "assistant": {
    "title": "Atlas Assistant",
    "placeholder": "Type your question…",
    "send": "Send",
    "thinking": "Atlas is typing…",
    "newConversation": "New conversation",
    "resetConfirmTitle": "Start a new conversation?",
    "resetConfirmText": "A blank chat will open. Each conversation and its entire history are deleted 24 hours after creation, even if you keep writing.",
    "emptyTitle": "How can I help?",
    "emptyText": "Ask me about Ekselans products: specifications, datasheets, manuals and availability.",
    "suggestion1": "Which WiFi 6 access points do you have?",
    "suggestion2": "Show me the AX 3000 datasheet",
    "suggestion3": "How do I request a warranty extension?",
    "you": "You",
    "assistantName": "Atlas",
    "disclaimer": "Atlas can make mistakes. Always check references before confirming an order.",
    "unavailableTitle": "The assistant is unavailable",
    "unavailableText": "We couldn't reach Atlas. Please try again in a few minutes.",
    "drawingDiagram": "Drawing the diagram…",
    "downloadDiagram": "Download the diagram as PNG",
    "diagramFileName": "atlas-diagram",
    "enlargeImage": "Enlarge the image",
    "enlargeDiagram": "Enlarge the diagram",
    "stop": "Stop the response",
    "stopped": "Response stopped",
    "copyAnswer": "Copy the answer",
    "jumpToLatest": "Jump to the latest message",
    "threadLabel": "Conversation with Atlas",
    "charsLeft_one": "{{count}} character left",
    "charsLeft_other": "{{count}} characters left",
    "charLimit": "You have reached the {{max}} character limit.",
    "resetConfirmAction": "Start over",
    "sendFailed": "The message could not be sent.",
    "composerHint": "Enter to send · Shift+Enter for a line break",
    "conversations": "Conversations",
    "showConversations": "Show conversations",
    "hideConversations": "Hide conversations",
    "untitled": "New conversation",
    "newChat": "New conversation",
    "noConversations": "You haven't talked to Atlas yet",
    "renameTitle": "Rename the conversation",
    "renameLabel": "Name",
    "removeTitle": "Delete this conversation?",
    "removeText": "The conversation and its transcript will be permanently deleted. This action cannot be undone.",
    "remove": "Delete",
    "conversationOptions": "Conversation options",
    "olderThanWeek": "Earlier",
    "thisWeek": "This week",
    "reasoning": "Atlas is thinking…",
    "reasoningSteps": {
      "searching": "Searching for information",
      "consulting": "Consulting the documentation",
      "comparing": "Comparing options",
      "verifying": "Verifying the details",
      "identifying": "Identifying the product",
      "clarifying": "Clarifying the requirements",
      "preparing": "Preparing the answer",
      "reviewing": "Analysing the request",
      "working": "Processing the request"
    }
  },
  "assistantWidget": {
    "needHelp": "Need help?",
    "productQuestion": "Any questions about a product?",
    "open": "Chat with the Atlas mascot",
    "title": "Atlas",
    "status": "Your product assistant",
    "greeting": "Hi! I'm Atlas. Ask me about a product, an equivalent or your next quote.",
    "expand": "Open the full Assistant",
    "placeholder": "Message Atlas…",
    "send": "Send message",
    "thinking": "Atlas is thinking…"
  },
  "auth": {
    "signInTitle": "Sign in to your portal",
    "signInSubtitle": "Track your requests and quotes in one place.",
    "email": "Email address",
    "password": "Password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgotten your password?",
    "signIn": "Sign in",
    "signingIn": "Signing in…",
    "secureAccess": "Secure access for Adaltra clients",
    "noAccount": "Don't have an account yet?",
    "createAccount": "Create an account",
    "haveAccount": "Already have an account?",
    "backToSignIn": "Back to sign in",
    "orContinueWith": "or continue with",
    "continueWithGoogle": "Continue with Google",
    "continueWithMicrosoft": "Continue with Outlook",
    "googleShort": "Google",
    "microsoftShort": "Outlook",
    "providerNotConfigured": "This sign-in method isn't configured yet. Add the credentials on the server to enable it.",
    "heroTitle": "From your bill of materials to a quote, without the hassle.",
    "heroSubtitle": "Photograph, review and confirm. You stay in control at all times.",
    "heroTitleRegister": "Start requesting quotes the easy way.",
    "heroSubtitleRegister": "Create your client portal access and bring all your company's requests together.",
    "trustDocuments": "Your documents, protected",
    "trustReview": "Human review before sending",
    "trustSecureSignUp": "Secure, protected sign-up",
    "trustTracking": "Tracking from day one",
    "registerTitle": "Create your access",
    "registerSubtitle": "Register your company's main details to start using the portal.",
    "fullName": "Full name",
    "phone": "Phone",
    "companyName": "Company",
    "taxId": "VAT number",
    "createAccountAction": "Create account",
    "registeredTitle": "We have your details",
    "registrationReceived": "The Adaltra team will verify your company details and send your access to the email provided.",
    "forgotTitle": "Recover your password",
    "forgotSubtitle": "Enter your email and we'll send you a link to create a new password.",
    "sendLink": "Send link",
    "resetEmailSent": "If that email matches a registered account, you'll receive a link to reset your password.",
    "resetTitle": "Create a new password",
    "newPassword": "New password",
    "repeatPassword": "Repeat password",
    "passwordUpdated": "Password updated. You can now sign in.",
    "passwordHint": "At least 10 characters, combining letters and numbers.",
    "currentPassword": "Current password",
    "changePassword": "Change password",
    "setPassword": "Set a password",
    "heroAccent": "the hassle.",
    "heroAccentRegister": "easy way.",
    "trustDevice": "Trusted device",
    "trustDeviceHint": "Skip the code on this browser for 30 days."
  },
  "authProvider": {
    "google": "Signed up with Google",
    "microsoft": "Signed up with Outlook",
    "password": "Signed up with a form"
  },
  "brand": {
    "name": "Atlas",
    "portal": "Client portal",
    "poweredBy": "Powered by",
    "version": "Version {{version}}",
    "company": "Adaltra"
  },
  "budget": {
    "period": "Issue date",
    "dateFrom": "From",
    "dateTo": "To",
    "invalidDates": "The end date must be on or after the start date.",
    "paginationSummary": "{{from}}–{{to}} of {{total}} quotes",
    "periods": {
      "all": "All dates",
      "today": "Today",
      "week": "Last 7 days",
      "month": "Last 30 days",
      "quarter": "Last 90 days",
      "year": "This year",
      "custom": "Custom range"
    },
    "listTitle": "Quotes",
    "listSubtitle": "View and download your approved orders.",
    "refresh": "Refresh",
    "refreshing": "Refreshing…",
    "searchPlaceholder": "Search by reference or project",
    "emptyTitle": "No quotes yet",
    "emptyText": "Quotes will appear here once you have accepted the order.",
    "validUntil": "Valid until",
    "issuedOn": "Issued on",
    "detailTitle": "Quote details",
    "linkedRequest": "Linked request",
    "downloadPdf": "Download PDF",
    "approve": "Approve quote",
    "reject": "Reject",
    "approveDialogTitle": "Approve the quote?",
    "approveDialogText": "Once approved, Adaltra will start preparing the order.",
    "rejectDialogTitle": "Reject the quote?",
    "rejectDialogText": "Tell us why so we can put together a better proposal.",
    "rejectReason": "Reason for rejection",
    "approvedMessage": "Quote approved",
    "rejectedMessage": "Quote rejected",
    "pendingEyebrow": "AWAITING APPROVAL",
    "pendingTitle": "Review and approve your quote",
    "pendingText": "Check the amount and the terms before confirming the proposal.",
    "draftEyebrow": "Not final yet",
    "draftTitle": "Your quote is being reviewed",
    "draftText": "It is ready and an Adaltra sales rep is going over it. You can look at it meanwhile, but the figures may still change: you will be able to accept or decline it once they send it to you.",
    "approvedEyebrow": "QUOTE APPROVED",
    "approvedTitle": "Quote approved",
    "approvedText": "The proposal has been approved and you can download the final document.",
    "orderedEyebrow": "CONVERTED TO ORDER",
    "orderedTitle": "Order {{order}} created",
    "orderedText": "The quote was won and the order has been processed in MTR.",
    "sentEyebrow": "QUOTE SENT",
    "sentTitle": "Your quote is ready",
    "sentText": "Review the summary and download the full document as a PDF.",
    "expiredEyebrow": "QUOTE EXPIRED",
    "expiredTitle": "This quote has expired",
    "expiredText": "Request an update to review prices and availability.",
    "rejectedEyebrow": "QUOTE REJECTED",
    "rejectedTitle": "You rejected this quote",
    "rejectedText": "You can request a new proposal whenever you need one.",
    "commercialRejectedEyebrow": "QUOTE NOT APPROVED",
    "commercialRejectedTitle": "It did not pass commercial review",
    "commercialRejectedText": "You can request a new proposal.",
    "unitPrice": "Unit price",
    "pricePending": "Price on request",
    "partialTotal_one": "The total is partial: the price of 1 product is still pending.",
    "partialTotal_other": "The total is partial: the prices of {{count}} products are still pending.",
    "discount": "Discount",
    "lineTotal": "Amount",
    "requestChanges": "Request changes",
    "requestChangesDialogTitle": "What needs fixing?",
    "requestChangesDialogText": "The quote goes back to Adaltra with your note and stays alive: you are not rejecting it. You will get a corrected proposal.",
    "requestChangesLabel": "What to review",
    "requestChangesHint": "Point out the line, quantity or reference that is wrong. The more specific, the faster it comes back fixed.",
    "changesSentMessage": "We have sent your request to Adaltra",
    "changesEyebrow": "CHANGES REQUESTED",
    "changesTitle": "Adaltra is reviewing your request",
    "changesText": "You will receive a corrected proposal. Meanwhile you can still accept or reject it as it stands.",
    "changesNoteLabel": "What you asked to fix",
    "viewPdf": "View the PDF",
    "hidePdf": "Hide the PDF",
    "openPdfInTab": "Open in a tab",
    "pdfNotReady": "The PDF is not available yet",
    "pdfNotReadyText": "Adaltra will attach it once signed. The line detail below is already final.",
    "pdfFallback": "Your browser cannot display the PDF here. Open it in a tab or download it.",
    "revision": "Revision {{count}}",
    "expiredOn": "Expired on {{date}}",
    "expiresToday": "Expires today",
    "expiresIn_one": "Expires in {{count}} day",
    "expiresIn_other": "Expires in {{count}} days",
    "requestAgain": "Request a new one",
    "decide": "Decide"
  },
  "budgetStatus": {
    "draft": "Under sales review",
    "sent": "Sent",
    "pending_approval": "Awaiting approval",
    "approved": "Approved",
    "rejected": "Rejected",
    "expired": "Expired",
    "changes_requested": "Changes requested",
    "ordered": "Order created"
  },
  "common": {
    "openInNewTab": "Open in new tab",
    "continue": "Continue",
    "back": "Back",
    "cancel": "Cancel",
    "save": "Save",
    "saveChanges": "Save changes",
    "saved": "Changes saved",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "search": "Search",
    "filter": "Filter",
    "all": "All",
    "close": "Close",
    "confirm": "Confirm",
    "download": "Download",
    "retry": "Try again",
    "loadMore": "Load more",
    "loading": "Loading…",
    "saving": "Saving…",
    "sending": "Sending…",
    "optional": "Optional",
    "required": "Required",
    "yes": "Yes",
    "no": "No",
    "of": "of",
    "page": "Page",
    "quantity": "Quantity",
    "unit": "Unit",
    "description": "Description",
    "code": "Code",
    "reference": "Reference",
    "brandLabel": "Brand",
    "date": "Date",
    "status": "Status",
    "total": "Total",
    "subtotal": "Subtotal",
    "vat": "VAT",
    "project": "Project",
    "actions": "Actions",
    "noResults": "No results",
    "seeAll": "See all",
    "seeDetail": "View details",
    "preview": "Preview",
    "rotate": "Rotate",
    "zoom": "Zoom in",
    "empty": "No data yet",
    "copy": "Copy",
    "copied": "Copied",
    "dismiss": "Dismiss",
    "rename": "Rename",
    "today": "Today",
    "yesterday": "Yesterday",
    "showMore": "Show more",
    "showLess": "Show less",
    "view": "View",
    "catalogName": "catalogue",
    "brand": "Brand"
  },
  "dashboard": {
    "attentionAllDone": "All caught up",
    "attentionAllDoneText": "Nothing is waiting on you. Create a request whenever you need one.",
    "attentionNextStep": "Next step",
    "attentionTitle": "Needs your attention",
    "createFirst": "Create your first request",
    "emptyBudgets": "Your quotes will appear here once they're ready.",
    "emptyRequests": "You haven't created any requests yet.",
    "greeting": "{{salutation}}, {{name}}",
    "greetings": {
      "morning": "Good morning",
      "afternoon": "Good afternoon",
      "night": "Good evening"
    },
    "groupDecide": "Ready for your decision",
    "groupDecideText": "Accept them, request changes or reject them.",
    "groupExpired": "Expired",
    "groupExpiredText": "They can no longer be accepted. Request a new one if you still need it.",
    "groupReview": "Waiting for your review",
    "reviewReadingText": "The document reading needs your confirmation.",
    "reviewProductsText": "Review the list and resolve the remaining products.",
    "reviewRecommendationsText": "Atlas recommendations still need your review.",
    "reviewConfirmationText": "The list has been reviewed. Confirm and send the request.",
    "groupReviewText": "Atlas has read the list. Check it and correct whatever is off.",
    "readingErrorText": "The file could not be read. Open the request to retry the analysis or change the files.",
    "groupSubmitted": "Sent to Atlas",
    "groupSubmittedText": "We are preparing the quote.",
    "inProgressText": "We are working on it. Nothing needed from you.",
    "inProgressViewAll": "View all {{count}} requests in progress",
    "inProgressTitle": "In progress",
    "itemsAndLines": "{{count}} lines",
    "newRequestCta": "New quote request",
    "newRequestHint": "Photograph your bill of materials or upload it as a file.",
    "recentBudgets": "Latest quotes",
    "recentEmpty": "Your requests and quotes will appear here as they are closed.",
    "recentRequests": "Latest requests",
    "recentTitle": "Your recent activity",
    "reviewCta": "Review request",
    "seeBudgets": "See all quotes",
    "seeRequests": "See all requests",
    "statApprovedBudgets": "Quotes approved",
    "statApprovedTotal": "Approved amount",
    "statDecision": "Awaiting your decision",
    "statReview": "Awaiting your review",
    "statTotalBudgets": "Total quotes",
    "statOpenRequests": "Requests in progress",
    "statPendingBudgets": "Quotes pending",
    "subtitle": "Here's the status of your requests and quotes.",
    "summaryCount": "{{count}} quotes",
    "summaryTitle": "Approved so far",
    "toDecide": "Ready for your decision",
    "toReview": "Waiting for your review",
    "validatedQuoteText": "The quote is validated and available to view or download before accepting it.",
    "viewValidatedQuote": "View quote",
    "attentionEmpty": "You have no requests or quotes waiting for review.",
    "inProgressEmpty": "Your requests will appear here while Atlas prepares your quotes.",
    "inProgressOpen": "View ongoing requests"
  },
  "valuation": {
    "informational": "Prices calculated by Ada-quote for the selected customer and destination. The delivery date and order number remain saved in Atlas; this query does not apply them.",
    "basePrice": "Base price",
    "unitPriceNet": "Net price",
    "literalDiscounts": "D1, D2 and D3 are the literal discounts received, in their original order. Their type and basis are unconfirmed; no percentages are inferred or recalculated.",
    "queriedAt": "Checked (Spain time)",
    "informationalWaiting": "Prices received. Economic confirmation is still pending.",
    "receivedBlocked": "Atlas has saved the order details. Economic valuation is pending Ada-quote integration.",
    "noDiscounts": "No discounts",
    "title": "Order valuation",
    "subtitle": "Review the prices and discounts applied to this customer before confirmation.",
    "request": "Get valuation",
    "refresh": "Refresh valuation",
    "pending": "Ada-quote is preparing the valuation…",
    "notRequested": "Request the valuation to receive this customer’s prices and terms. This step does not confirm an order.",
    "stale": "The previous valuation is no longer current. Review the customer, address and quantities before requesting prices again.",
    "expired": "The valuation has expired. Refresh it to review current amounts.",
    "linesTitle": "Valued products",
    "article": "Item",
    "quantity": "Quantity",
    "unitPrice": "Unit price",
    "discounts": "Discounts",
    "netUnitPrice": "Discounted price",
    "lineTotal": "Amount",
    "sourceNotice": "Prices, discounts and amounts are displayed as supplied by Ada-quote.",
    "addedByProvider": "Added by Ada-quote (not in the list)",
    "addedWarning": "Warning",
    "addedWillRemove": "It will be removed from the order.",
    "addedNotesHint": "The decision is sent to Ada-quote in the quote notes.",
    "addedTitle": "Ada-quote has added products to the order",
    "addedIntro": "While valuing, Ada-quote added products that were not in the list. Decide whether they stay in the order and, if you want, set their price.",
    "addedKeep": "Keep",
    "addedRemove": "Remove",
    "addedPrice": "Unit price (€)",
    "addedPriceHelp": "Empty: Ada-quote’s price is kept ({{price}}).",
    "addedAdaPrice": "Ada-quote price: {{price}}",
    "addedSave": "Save decision",
    "addedLater": "Later",
    "addedChange": "Change",
    "addedRemoved": "Removed from the order",
    "addedPriceChanged": "Price set by Orders",
    "addedPending": "Decide whether to keep the products Ada-quote added before continuing.",
    "addedAdjusted": "Amounts adjusted with your decision on the products added by Ada-quote. The decision is sent to Ada-quote in the order notes.",
    "addedPriceInvalid": "Enter a valid price (for example, 25 or 25.50).",
    "totalsTitle": "Price summary",
    "subtotal": "Gross amount",
    "discount": "Total discount",
    "netSubtotal": "Net subtotal",
    "tax": "Taxes",
    "total": "Total",
    "quoteReference": "Quote",
    "continue": "Reviewed, continue to Confirmation",
    "ready": "Valuation received. Review the amounts before continuing.",
    "waiting": "A current valuation must be available and reviewed before confirmation."
  },
  "errors": {
    "valuationUncertain": "The query result could not be confirmed. The attempt is retained and will not be resent automatically.",
    "valuationIntegrationPending": "Pricing is pending integration with Ada-quote. No prices are available for this order yet.",
    "valuationUnavailable": "The valuation cannot be retrieved right now. Try again.",
    "valuationInvalid": "The valuation does not match this list or contains invalid pricing data.",
    "valuationChanged": "The valuation or list has changed. Refresh and review the amounts again.",
    "valuationAdditionalLinesPending": "Decide whether to keep the products Ada-quote added before continuing.",
    "valuationNotApplicable": "This step is available only for requests with an assigned customer.",
    "valuationReviewRequired": "Get and review a current valuation before confirming the order.",
    "requesterEmailUnavailable": "The requesting user's email cannot be verified. Check their account before continuing.",
    "customerAssignmentNotEnabled": "The order details are saved. Commercial submission is pending Ada-quote integration.",
    "customerAssignmentUnavailable": "Customer assignment is not yet enabled in this environment.",
    "customerAssignmentChanged": "Customer details have changed. Search and select the customer and address again before saving.",
    "customerAssignmentAddressInvalid": "The selected address does not belong to this customer or is no longer available.",
    "deliveryDateInPast": "The delivery date cannot be earlier than today.",
    "customerAssignmentIncomplete": "Select a customer and delivery address before saving order details.",
    "customerAssignmentRequired": "Choose the customer and delivery address to create the request.",
    "customerDirectoryUnavailable": "The Atlas customer directory is unavailable.",
    "customerDirectoryChanged": "The customer directory has changed. Select the customer and address again before saving changes.",
    "customerDirectoryNotFound": "Atlas could not find the customer or lookup route.",
    "customerDirectoryInvalid": "Atlas returned an invalid customer response.",
    "atlasTestUnavailable": "Atlas Test is unavailable or its connection has changed. Another API will not be used automatically.",
    "atlasTestIdentity": "The server does not confirm its Atlas Test identity. Check the configuration before analyzing.",
    "atlasTestFormatUnsupported": "Atlas Test does not yet confirm support for all formats in this request.",
    "atlasTestCommercialDisabled": "This request belongs to Atlas Test and cannot send quotes or orders.",
    "installationVerificationRequired": "Atlas must verify the current material list before you confirm the request.",
    "installationInvalidResponse": "The proposal returned by Atlas could not be validated. No materials have been submitted.",
    "installationUnavailable": "Installation planning is not yet available on this Atlas connection. Your description has been saved.",
    "installationFailed": "Atlas could not complete this operation. You can retry without submitting the quote.",
    "installationChanged": "The request or Atlas review has changed. Refresh the page to continue with the current version.",
    "installationRequiresEmptyDraft": "This method requires a request without documents or materials from another method. Keep this request and create a new one to describe the installation.",
    "installationCatalogChanged": "A product or its unit no longer matches the current catalogue. Review your selection before continuing.",
    "identityOptionsChanged": "Atlas has updated the alternatives. Review the current options and choose again.",
    "identitySelectionRequired": "Select an Atlas alternative or indicate that none match.",
    "catalogProductRequired": "Choose a catalogue product to replace the Atlas suggestion.",
    "mandatoryDependenciesInvalid": "Licences were not applied because the response is invalid or the proposal changed. Analyse again.",
    "pendingUnits": "Some units require confirmation.",
    "pendingQuantities": "Some quantities are still pending. Review them before continuing with the quotation.",
    "unitProvenanceProtected": "These lines retain units from the original document. Edit them individually; the complete list cannot be replaced in manual mode.",
    "adaQuoteCustomerDataMissing": "Atlas needs complete customer details before sending to AdaQuote.",
    "submissionRetryUnsafe": "Cannot resend until it is confirmed that AdaQuote has not received the job. Refresh the status.",
    "submissionChecking": "Checking the resend result. Refresh the status before trying again.",
    "accountBlocked": "Your account isn't active. Please contact Adaltra.",
    "accountPending": "Your account is awaiting verification by Adaltra. We'll email you.",
    "assistantDisabled": "The assistant is disabled in this environment.",
    "assistantFailed": "The assistant couldn't reply. Please try again.",
    "assistantSessionLost": "That conversation is no longer available.",
    "assistantTimeout": "The assistant took too long to reply.",
    "assistantUnavailable": "We couldn't reach the assistant.",
    "badRequest": "The request isn't valid.",
    "badSignature": "The signature is not valid.",
    "budgetExpired": "The quote has expired and can't be approved.",
    "budgetNotExtendable": "This quote can no longer be extended.",
    "budgetNotFound": "We couldn't find that quote.",
    "budgetNotRemindable": "This quote is not awaiting a decision.",
    "companyEditForbidden": "Only the account manager can change these details.",
    "companyNotFound": "We couldn't find that company.",
    "conflict": "That operation can't be completed right now.",
    "conversationNotFound": "That conversation is no longer available.",
    "currentPasswordInvalid": "The current password isn't correct.",
    "documentNotReady": "The document isn't available yet.",
    "duplicate": "That record already exists.",
    "emailAlreadyRegistered": "That email is already registered.",
    "fileNotFound": "We couldn't find that file.",
    "fileTooLarge": "The file is larger than the maximum allowed.",
    "documentInvalid": "One of the files is damaged or is not the type its extension says, so Atlas cannot read it. Open it, save it again (or export it again to PDF/Excel) and upload it again.",
    "documentUnsupported": "Atlas cannot read one of the files because of its type. Upload it as PDF, Excel (XLSX/XLS), CSV or an image.",
    "documentEmpty": "One of the files is empty. Check the file and upload it again.",
    "forbidden": "You don't have permission to do that.",
    "genericText": "We've logged the problem. You can try again.",
    "releaseNotFound": "We couldn't find the release.",
    "platformRequestNotFound": "We couldn't find the improvement request.",
    "genericTitle": "Something went wrong",
    "hermesDisabled": "The Atlas integration is turned off.",
    "hermesIncomplete": "Fill in the address and the API key before turning it on.",
    "smtpIncomplete": "Configure an SMTP URL or server before enabling email.",
    "smtpNotConfigured": "The SMTP service is not configured or is disabled.",
    "emailAudienceEmpty": "There are no active users with the selected role.",
    "pushIncomplete": "Configure the VAPID keys and service contact before enabling push notifications.",
    "hermesNotReady": "The Atlas integration is not configured.",
    "hermesRejected": "Atlas rejected the job.",
    "hermesRequestRefAlreadySubmitted": "This number was already used for another request in AdaQuote. Your list is saved and needs a new number before it can be submitted.",
    "hermesRequestRefConflict": "Atlas already has a different list linked to this request number. Your materials are saved; contact Adaltra to review the submission.",
    "recognitionUpdatedConcurrently": "The request was updated in another session. Close this form and reload the page before continuing.",
    "documentReviewChanged": "The Atlas review or catalogue has changed. Reload the request and check the list before continuing.",
    "documentReviewRejected": "Atlas could not accept confirmation of the list. Your products are preserved. The integration needs to be checked.",
    "hermesTimeout": "Atlas did not reply in time.",
    "hermesUnreachable": "Could not connect to Atlas.",
    "invalidCredentials": "The email or password is incorrect.",
    "invalidEmail": "That email address isn't valid.",
    "invalidIdentifier": "That identifier isn't valid.",
    "invalidProductReference": "The product reference is not valid.",
    "invalidQuantity": "That quantity isn't valid.",
    "invalidTransition": "That action isn't possible in the current state.",
    "lineNotFound": "We couldn't find that line.",
    "includedComponentReadOnly": "This component is included. Edit the parent rack to update its quantity.",
    "includedComponentUnbound": "An ACC SRP line has no verified parent rack. Explicit review is required before continuing.",
    "invalidEquivalenceConfirmation": "This line does not contain an equivalence that can be confirmed.",
    "network": "We couldn't reach the server. Check your connection.",
    "serviceUnavailable": "The service is recovering. Wait a few seconds and try again.",
    "noFilesProvided": "Add at least one file.",
    "noFilesToProcess": "Add at least one document before processing.",
    "noLinesToSubmit": "Add at least one line before sending.",
    "pendingProducts": "Identify every pending product before continuing.",
    "pendingAtlasSuggestions": "Confirm, change or remove the products suggested by Atlas before continuing.",
    "documentReviewPending": "Finish reviewing the document readings before continuing.",
    "pendingEquivalences": "Confirm the proposed equivalences before continuing.",
    "notFound": "We couldn't find what you were looking for.",
    "notificationNotFound": "We couldn't find that notification.",
    "pushNotConfigured": "Push notifications are not configured on the server.",
    "oauthEmailNotVerified": "That account's email isn't verified.",
    "oauthFailed": "We couldn't complete the sign-in. Please try again.",
    "oauthNoEmail": "The provider didn't supply an email address.",
    "oauthSessionLost": "The sign-in session expired. Please try again.",
    "onlyDraftsCanBeDeleted": "Only drafts can be deleted.",
    "onlyDraftsOrCancelledCanBeDeleted": "Only drafts or cancelled requests can be deleted.",
    "requestNotCancelled": "The request is not cancelled.",
    "cancellationExpired": "The deadline for reactivating the request has passed.",
    "cancellationCannotBeUndone": "This cancellation cannot be undone.",
    "pageNotFoundText": "The link you followed doesn't exist or has moved.",
    "pageNotFoundTitle": "Page not found",
    "passwordTooLong": "That password is too long.",
    "passwordTooShort": "The password must be at least 10 characters.",
    "passwordTooSimple": "The password must combine letters and numbers.",
    "passwordsDontMatch": "The passwords don't match.",
    "productImageNotFound": "That product has no image available.",
    "providerNotConfigured": "That sign-in method isn't available right now.",
    "registrationAlreadyReviewed": "That sign-up request has already been reviewed.",
    "registrationNotFound": "We couldn't find that sign-up request.",
    "requestNotEditable": "This request can no longer be edited.",
    "requestNotFound": "We couldn't find that request.",
    "requiredField": "This field is required.",
    "resetLinkInvalid": "The link has expired or has already been used.",
    "routeNotFound": "That address doesn't exist.",
    "ticketNotFound": "We couldn't find that ticket.",
    "tooManyAttempts": "Too many attempts. Wait a few minutes and try again.",
    "tooManyFiles": "You've reached the maximum number of files.",
    "tooManyMessages": "You've sent too many messages in a row. Please wait a moment.",
    "unauthorized": "Your session has expired. Please sign in again.",
    "unexpected": "Something went wrong. Please try again.",
    "userNotFound": "We couldn't find that user.",
    "cannotModifyOwnAccess": "You cannot remove your own administrator access.",
    "unknownProvider": "That sign-in method doesn't exist.",
    "unsupportedFileType": "That file type isn't supported.",
    "uploadFailed": "We couldn't upload the file.",
    "upstream": "An external service did not respond properly.",
    "validUntilMustBeFuture": "The new date must be in the future.",
    "validation": "Please check the details you entered.",
    "adaQuoteIncomplete": "Fill in the address and the key before turning it on.",
    "adaQuoteCustomerCodeMissing": "Your company details are missing the AdaQuote customer code.",
    "adaQuoteReadFailed": "We could not retrieve your quotes from Ada-quote. Please try again.",
    "adaQuotePdfNotReady": "This quote’s PDF is not available yet. Try again later or contact administration.",
    "adaQuotePdfCustomerMismatch": "The quote does not match this request’s customer code. Contact administration.",
    "adaQuotePdfUnavailable": "Could not retrieve the quote PDF. Please try again.",
    "adaQuotePdfInvalid": "A valid PDF was not received.",
    "atlasPdfUnavailable": "Atlas cannot deliver the quote PDF yet. Please try again later.",
    "atlasPdfIdentityConflict": "Atlas returned a different quote identity. The document will not be displayed; contact administration.",
    "adaQuotePdfNotValidated": "The PDF will be available after commercial validation.",
    "hermesSignatureRequired": "Auto-sending jobs requires the signing secret.",
    "catalogMasterChanged": "The price master changed while copying. Try again.",
    "catalogTooManyPages": "The catalogue copy does not finish. Check the Atlas connection.",
    "catalogNoVersion": "Atlas did not report which master version it has.",
    "catalogProductUnavailable": "The selected product is no longer available in the catalogue. Refresh the options and try again.",
    "recognitionUnusable": "Atlas returned a result the portal could not store. Please try again.",
    "recognitionVisualAnalysisUnavailable": "Atlas visual analysis is currently unavailable. Your files are saved; you can try again later without replacing them.",
    "recognitionFailed": "Recognition failed.",
    "documentAnalysisUnavailable": "Atlas could not start the analysis. Your files are saved; you can try again later without uploading them again.",
    "recommendationsRejected": "Atlas could not start the recommendation analysis.",
    "recommendationsNeedRecognition": "This list does not yet have a recognition result Atlas can analyse.",
    "recommendationsNotReady": "Recommendations are not ready yet.",
    "recommendationNotFound": "This recommendation is no longer available.",
    "recommendationAlreadyDecided": "This recommendation has already been reviewed.",
    "recommendationNeedsInput": "Answer the pending questions first.",
    "recommendationMissingProduct": "Atlas did not associate a valid product with this recommendation.",
    "recommendationCatalogStale": "The catalogue has changed. Analyse the recommendations again.",
    "recommendationReplacementMissing": "Atlas did not identify which product must be replaced. Analyse the recommendations again.",
    "recommendationsPending": "Review Atlas recommendations before submitting.",
    "recommendationQuestionsPending": "Answer Atlas questions before continuing.",
    "recommendationDecisionsPending": "Add or dismiss every recommendation before continuing.",
    "unitReviewChanged": "The line changed after you opened it. Reload the request and review its unit again.",
    "unitAnswerUnresolved": "Atlas has not confirmed the chosen unit. The question remains pending; your selection has not been applied.",
    "quantityAnswerUnresolved": "Atlas has not applied the entered quantity yet. The review remains pending; please try again.",
    "installationReferenceSize": "Reference files can be up to 10 MB each and 20 MB in total.",
    "installationReferenceInvalid": "The reference file cannot be read. Check that it is a valid PDF or image.",
    "installationReferenceLocked": "To change the files, return to the description and start a new analysis.",
    "installationReferencesUnavailable": "This Atlas connection does not support reference files yet. Your files and description are saved.",
    "requestChangedConcurrently": "The request changed while you were saving. Refresh the page and try again.",
    "semanticResolutionFailed": "Atlas could not complete the interpretation. Try again or check the document.",
    "visualReviewConfirmationRequired": "Atlas does not yet consider the photo reading confirmed. Use «Re-analyze» in the request menu to read it again and confirm it.",
    "readingConnectionChanged": "This request's reading connection has changed. The analysis will not be sent anywhere else.",
    "simpleReadingUnavailable": "Simplified reading is not available. The request will not switch to another connection automatically.",
    "simpleReadingFormatUnsupported": "Simplified reading accepts PDFs and images; this file type is not available yet.",
    "simpleReadingImagesUnchecked": "We could not check whether Atlas reads images. Your files are still saved; please try again.",
    "simpleReadingImagesDisabled": "Atlas does not read images in simplified reading yet. Your photo is still saved; you can analyse it once it is available.",
    "readingConnectionLocked": "This request is already bound to its reading connection. Create another request to compare.",
    "processingRequestChanged": "The request has changed. Refresh the page before analysing.",
    "recognitionJobGone": "Atlas no longer has this analysis. Your files are still saved; analyse them again.",
    "recognitionServiceUnavailable": "Atlas has not responded about this analysis for several minutes. Your files are still saved; please try again later.",
    "recognitionStartInterrupted": "We could not confirm that the analysis started. Your files are still saved; analyse them again.",
    "recognitionNotRestarted": "Atlas did not start a new reading because it still holds the previous one. Wait a few minutes and analyse again.",
    "typedTextEmpty": "First type your list or the description of your installation.",
    "typedTextInvalidCharacters": "The text contains characters Atlas cannot read (for example, control characters pasted from another program). Remove them and send it again.",
    "typedTextTooLarge": "The text is too long for Atlas to read at once (maximum 4,000 characters and 16 KB). Shorten it or split it into several requests.",
    "typedTextTooManyLines": "The text has too many lines for Atlas to read at once (maximum 300). Group lines together or split it into several requests.",
    "typedTextRequiresOneFile": "Atlas reads typed text on its own, without other documents. Remove the documents or send the text in another request.",
    "typedTextNoMaterials": "Atlas did not find any product in the text. Check it (for example, “20 cat6 outlets”) or describe it as an installation.",
    "typedTextUnsupported": "This Atlas connection cannot read typed text as a list yet. Send the description as an installation or fill in the list manually.",
    "twoFactorInvalid": "Incorrect code. Try again.",
    "twoFactorExpired": "This code has expired or has already been used. Sign in again.",
    "twoFactorLocked": "Too many attempts. Wait 15 minutes before signing in again.",
    "twoFactorResendWait": "Please wait before requesting another code. If you have used all resends, sign in again.",
    "twoFactorDelivery": "The code could not be emailed. Please try again later.",
    "closedOrderRecommendationsDisabled": "Closed orders go from Review to Confirmation without recommendations.",
    "wordConverterUnavailable": "Word to PDF conversion is unavailable. Upload a PDF or try again later.",
    "wordConversionFailed": "The Word document could not be converted to PDF. Check that it is not damaged or password protected, or upload a PDF.",
    "resetRequiresActiveUser": "Only active accounts can be required to change their password.",
    "passwordChangeRequired": "An administrator requires a password change. Open the email link or request one from Forgotten your password? to sign in again.",
    "cannotForceOwnPasswordReset": "Change your own password from your profile.",
    "passwordResetCooldown": "Wait one minute before sending another email.",
    "passwordResetEmailFailed": "The email could not be sent. The account has not been blocked; check email settings and try again.",
    "cannotDeleteOwnUser": "You cannot delete your own account.",
    "userSecurityChanged": "The account changed during this operation. Refresh the list and try again.",
    "customerOrderRequired": "Requests with an assigned customer are sent with “Won and convert to order”.",
    "customerOrderUnavailable": "Converting to order is not available in Atlas yet.",
    "customerOrderInvalid": "Atlas returned an invalid order response.",
    "customerOrderConflict": "The request has changed. Reload and try again.",
    "customerOrderUnreachable": "Atlas could not be reached. You can retry: the order will not be duplicated.",
    "customerOrderNotApplicable": "This request has no assigned customer.",
    "customerOrderDataMissing": "The delivery date or the customer order number (step 1) is missing to convert to order.",
    "atlasMaintenance": "Atlas is under maintenance. The request is queued and will be processed automatically afterwards."
  },
  "help": {
    "title": "Help centre",
    "subtitle": "Answers about the portal and the quoting process.",
    "guides": "Guides",
    "faq": "Frequently asked questions",
    "contactTitle": "Need a hand?",
    "contactText": "Tell us what happened and include the request or quote reference, if you have it.",
    "contactCta": "Contact support",
    "guidePhotoTitle": "How to take a good photo",
    "guidePhotoIntro": "Get more accurate recognition by preparing each image properly.",
    "guidePhotoStep1": "Place the list on a flat surface with good lighting.",
    "guidePhotoStep2": "Frame the whole sheet, without cutting off references or quantities.",
    "guidePhotoStep3": "Avoid glare, shadows and tilted photos.",
    "guidePhotoStep4": "Check that the text is legible before continuing.",
    "guidePhotoTip": "If there are several pages, photograph them in order. You'll be able to review them all before processing starts.",
    "guideLinesTitle": "How to correct the items",
    "guideLinesIntro": "Check the document reading and the selected product before sending the list.",
    "guideLinesStep1": "If Readings to confirm appears, check the text, quantity and unit of each row. Use edit to correct them and confirm to save the reading.",
    "guideLinesStep2": "Confirming the text does not always identify the product. If Atlas asks you to select a reference, answer the question or search the catalogue by code or reference.",
    "guideLinesStep3": "In the materials list, check the product, quantity and unit. Open edit to change a row; confirm any rows requiring your approval.",
    "guideLinesStep4": "Remove or exclude materials you do not want to include when the screen allows it. Resolve pending quantities or units before continuing.",
    "guideLinesTip": "A correctly recognised reference does not replace checking the quantity and unit. Check, for example, whether cable is requested in metres or pieces.",
    "guideBudgetTitle": "How the quote is produced",
    "guideBudgetIntro": "See the journey from your list to the commercial proposal.",
    "guideBudgetStep1": "Review the materials, quantities and units. Answer pending Atlas questions and decide on any suggestions shown.",
    "guideBudgetStep2": "At Confirmation, review the summary and tick that you have reviewed the materials and quantities. Select Send request to request the quote.",
    "guideBudgetStep3": "Check progress in My requests and notifications. Once the quote is available, open it from Quotes.",
    "guideBudgetStep4": "Review prices and conditions. Download the document when available and use the approval, change or rejection actions offered by the quote.",
    "guideBudgetTip": "The amount shown before submission is an estimate. Check the generated quote’s prices and conditions before approving it.",
    "guidePrivacyTitle": "Privacy of your documents",
    "guidePrivacyIntro": "Your files are used solely to handle your request.",
    "guidePrivacyStep1": "Documents are linked to your client account.",
    "guidePrivacyStep2": "Only authorised staff can view their contents.",
    "guidePrivacyStep3": "You can ask about retention or deletion at any time.",
    "guidePrivacyStep4": "We never share your files for advertising purposes.",
    "guidePrivacyTip": "See the full privacy policy for more information.",
    "faqTimeQ": "How long does my quote take?",
    "faqTimeA": "Timing depends on the analysis and required checks. You can check the status in My requests; you will receive a notification when there are updates.",
    "faqEditQ": "Can I change a request I've already sent?",
    "faqEditA": "Once sent it can't be edited, but you can write to support quoting the reference.",
    "faqFormatsQ": "Which file formats can I upload?",
    "faqFormatsA": "You can upload JPG, PNG, WEBP or HEIC images, PDF and XLSX, XLS or CSV spreadsheets. Several files can be included in one request; check they are all attached before analysis.",
    "faqPriceQ": "Do the prices include VAT?",
    "faqPriceA": "The breakdown shows the net amount and VAT separately, plus the total including tax.",
    "shortcuts": "Quick links",
    "privacyAction": "View privacy policy",
    "guideStartTitle": "How to create a request",
    "guideStartIntro": "Choose the method that matches the information you have.",
    "guideStartStep1": "Select New request and enter the project details. Keep the SOL reference to find it later.",
    "guideStartStep2": "If you have a list, take a photo or upload PDF, image, Excel or CSV files. You can attach several files, such as a PDF and an image.",
    "guideStartStep3": "If you know the products, choose manual entry and search by code or reference. To have Atlas propose the materials, choose Describe your installation to Atlas.",
    "guideStartStep4": "Review the materials and suggestions. At final confirmation, check the summary, tick that you have reviewed the list and select Send request.",
    "guideStartTip": "Sending a description or uploading a file starts the analysis. The final request is sent after your review.",
    "guideAtlasTitle": "Describe your installation to Atlas",
    "guideAtlasIntro": "Explain what you need and review the materials Atlas proposes.",
    "guideAtlasStep1": "In a new request, select Describe your installation to Atlas. Include the goal, areas or floors, expected quantities and any equipment or cabling you already have. You can also attach plans, photos or PDFs as reference.",
    "guideAtlasStep2": "Select Send proposal. If details are missing, open each topic, answer the steps in the dialog and save your answers. Once all topics are complete, select Send answers.",
    "guideAtlasStep3": "When the proposal is ready, check each material’s code, reference, description and quantity. You can confirm, edit using the catalogue or remove rows.",
    "guideAtlasStep4": "Review the explanation of the components and any Atlas suggestions. Choose what to add and wait for the technical review to finish; any remaining question will appear in the portal.",
    "guideAtlasStep5": "At Confirmation, review the list and any available amount. Tick that you have reviewed the materials and quantities, then select Send request.",
    "guideAtlasTip": "Provisional materials are a preview. Actions become available once Atlas completes its checks; you can leave and resume the request.",
    "guideResumeTitle": "How to resume a request",
    "guideResumeIntro": "Continue a saved review and check what is pending.",
    "guideResumeStep1": "During analysis, use Exit or Exit and continue later. Open My requests and select the SOL reference to resume the pending step.",
    "guideResumeStep2": "If Atlas is processing or running technical checks, wait and check the status. A materials preview does not mean the proposal is ready to confirm.",
    "guideResumeStep3": "Complete any pending questions, readings, quantities or units shown on screen. Check notifications for updates as well.",
    "guideResumeStep4": "If an error appears, use Try again when offered. If it persists, contact support with the reference, step and what happened; a screenshot helps.",
    "guideResumeTip": "Save your answers or changes before leaving a dialog. Check that confirmations have finished saving before closing the screen.",
    "faqReadingQ": "Why do I need to confirm a reading?",
    "faqReadingA": "Atlas may need you to validate text, a quantity or a unit from the document. Confirming the reading saves these details; if the product still needs identifying, a question will appear to select it.",
    "faqSavedQ": "Can I leave while Atlas is working?",
    "faqSavedA": "Yes. The request is saved and you can resume it from My requests. First save dialog changes and wait for any confirmations in progress to finish.",
    "faqPendingQ": "What does Pending Atlas mean?",
    "faqPendingA": "Atlas is still completing the analysis or its checks. If there are no questions for you, check the status later. Provisional materials cannot be validated until the proposal is ready.",
    "faqUnavailableQ": "Why does a link say the request or quote is unavailable?",
    "faqUnavailableA": "The item may have been deleted or the link may be incorrect. Return to its list to find it. If you expected access and it does not appear, contact support with the reference."
  },
  "languages": {
    "es": "Español",
    "en": "English",
    "fr": "Français",
    "it": "Italiano"
  },
  "lineConfidence": {
    "high": "High confidence",
    "review": "Check reference",
    "incomplete": "Incomplete data",
    "corrected": "Corrected by you",
    "confirmed": "Confirmed",
    "manual": "Entered manually"
  },
  "nav": {
    "home": "Home",
    "newRequest": "New request",
    "requests": "Requests",
    "budgets": "Quotes",
    "assistant": "Atlas Assistant",
    "admin": "Administration",
    "notifications": "Notifications",
    "help": "Help",
    "profile": "Profile",
    "support": "Support",
    "privacy": "Privacy",
    "signOut": "Sign out",
    "signingOut": "Signing out…",
    "mobileNew": "New",
    "mobileHome": "Home",
    "mobileRequests": "Requests",
    "mobileBudgets": "Quotes",
    "mobileAssistant": "Assistant",
    "mobileProfile": "Profile",
    "changeLanguage": "Change language",
    "mainNavigation": "Main navigation",
    "mobileNavigation": "Mobile navigation",
    "hideSidebar": "Collapse the menu",
    "showSidebar": "Expand the menu",
    "preferences": "Preferences",
    "legalNotice": "Legal notice",
    "cookies": "Cookies",
    "legalInformation": "Legal information"
  },
  "notifications": {
    "budgetApprovedBody": "You approved {{ref}} · {{project}}. Adaltra is preparing the order.",
    "budgetApprovedTitle": "Quote approved",
    "budgetChangesBody": "Adaltra will review {{ref}} · {{project}} and send a corrected proposal.",
    "budgetChangesTitle": "Changes requested",
    "budgetExpiringBody": "Approve it before the validity date.",
    "budgetExpiringTitle": "Quote {{ref}} expires soon",
    "budgetExtendedBody": "We extended the validity of {{ref}}. You now have more time to decide.",
    "budgetExtendedTitle": "Quote extended",
    "budgetReadyBody": "You can now review and download it.",
    "budgetReadyTitle": "Your quote {{ref}} is ready",
    "budgetRejectedBody": "You rejected {{ref}} · {{project}}.",
    "budgetRejectedTitle": "Quote rejected",
    "budgetReminderBody": "{{ref}} is still awaiting your decision.",
    "budgetReminderTitle": "A quote is waiting for you",
    "budgetWithdrawnBody": "{{ref}} is no longer available. Get in touch if you are still interested.",
    "budgetWithdrawnTitle": "Quote withdrawn",
    "emptyText": "We'll let you know here when there's news.",
    "emptyTitle": "You have no notifications",
    "markAllRead": "Mark all as read",
    "panelError": "We could not load your notifications.",
    "panelUnread": "{{count}} unread",
    "viewAll": "View all notifications",
    "settingsButton": "Settings",
    "settingsTitle": "Notification settings",
    "deleteAll": "Delete",
    "deleteConfirmText": "Your entire notification history will be deleted. This action cannot be undone.",
    "deleteConfirmTitle": "Delete all notifications?",
    "channelsTitle": "Updates on every device",
    "channelsText": "Email and push follow your preferences. Enable push on each device where you want to receive notifications.",
    "enablePush": "Enable push",
    "disablePush": "Disable push",
    "pushChecking": "Checking push",
    "pushInactive": "Push disabled",
    "pushBlocked": "Push blocked",
    "pushUnavailable": "Push unavailable",
    "channelsTextActive": "Push notifications are enabled on this device and follow your preferences. You can disable them at any time.",
    "pushActive": "Push active",
    "pushEnabled": "Push notifications are enabled on this device.",
    "pushDisabled": "Push notifications are disabled on this device.",
    "pushDenied": "Your browser is blocking notifications for Atlas.",
    "pushError": "We could not update your push notification settings.",
    "pushRequiresHttps": "Push notifications and app installation require a secure HTTPS connection.",
    "pushNotConfigured": "The server VAPID keys are missing, so push notifications cannot be enabled.",
    "emailNotConfigured": "The SMTP server must be configured before emails can be sent.",
    "installApp": "Install app",
    "appInstalled": "App installed",
    "installHint": "On iPhone or iPad, use Share → Add to Home Screen.",
    "quoteFailedBody": "Something went wrong with {{ref}}. We are looking into it.",
    "quoteFailedTitle": "We could not prepare the quote",
    "quoteReadyBody": "{{ref}} is now available to review and accept.",
    "quoteInReviewTitle": "Your quote is being reviewed",
    "quoteInReviewBody": "{{ref}} is available to view. A sales rep is going over it before sending it to you.",
    "quoteRejectedByAdaQuoteBody": "{{ref}} did not pass the commercial review.",
    "quoteRejectedByAdaQuoteTitle": "Quote not approved",
    "quoteReadyTitle": "Your quote is ready",
    "requestProcessedBody": "Atlas has prepared {{ref}}. Review the products before sending it.",
    "requestProcessedTitle": "Request awaiting review",
    "requestReadingFailedTitle": "Document analysis failed",
    "requestReadingFailedBody": "Atlas could not complete the analysis of {{ref}}. Open the request to view the error and retry.",
    "requestReceivedBody": "Atlas has started preparing your quote.",
    "requestReceivedTitle": "Request {{ref}} received",
    "requestSubmittedBody": "{{ref}} · {{project}} is now with Atlas.",
    "requestSubmittedTitle": "Request sent",
    "subtitle": "Everything that's happened with your requests and quotes.",
    "title": "Notifications",
    "unread": "Unread",
    "maintenanceQueueStartedTitle": "Request sent to Atlas",
    "maintenanceQueueStartedBody": "Maintenance is over and {{ref}} is now being processed.",
    "maintenanceQueueFailedTitle": "The queued request could not be processed",
    "maintenanceQueueFailedBody": "{{ref}} could not be sent to Atlas after maintenance. Open it and press “Analyse” again."
  },
  "privacy": {
    "title": "Privacy policy",
    "subtitle": "How we handle the information you share with Adaltra.",
    "section1Title": "Data we collect",
    "section1Text": "Your account contact details, your company's details and the documents you upload to prepare a quote.",
    "section2Title": "What we use it for",
    "section2Text": "Solely to handle your requests, produce the quotes and support you. We never pass it on for advertising purposes.",
    "section3Title": "Retention",
    "section3Text": "We keep documents for the duration of the commercial relationship and for the periods required by tax law.",
    "section4Title": "Your rights",
    "section4Text": "You can request access to, correction of or deletion of your data by writing to our support team."
  },
  "profile": {
    "title": "Your profile",
    "subtitle": "Manage your details and your company's.",
    "personalData": "Personal details",
    "companyData": "Company details",
    "security": "Security",
    "preferences": "Preferences",
    "language": "Language",
    "languageHint": "It will apply across the portal and to the emails you receive.",
    "address": "Address",
    "city": "Town or city",
    "postalCode": "Postcode",
    "province": "Province",
    "adaQuoteCustomerCode": "AdaQuote customer code",
    "adaQuoteCustomerCodeHint": "Commercial code assigned to your company in AdaQuote.",
    "adaQuoteCustomerCodeReadOnlyHint": "Commercial code assigned by Adaltra. You can view it, but only an administrator can change it.",
    "linkedAccounts": "Linked accounts",
    "linkedAccountsHint": "You can sign in to the portal with any of these.",
    "companyReadOnly": "Only the account manager can change the tax details. Write to us if you need them updated.",
    "passwordChanged": "Password updated",
    "session": "Session",
    "sessionHint": "Sign out on this device."
  },
  "request": {
    "dateNotPast": "It cannot be earlier than today.",
    "orderAssignment": {
      "previewLabel": "Available",
      "savedLabel": "Saved",
      "savedHint": "Details saved with the request.",
      "previewHint": "Select the customer and delivery address. Order details will be saved when you continue or save changes.",
      "retryConnection": "Retry connection",
      "noCustomers": "No matching customers",
      "noAddresses": "No addresses available",
      "connecting": "Connecting to Atlas…",
      "searchHint": "Type at least two characters of the name, code or tax ID.",
      "sourceCount": "Customers available in Atlas: {{count}}",
      "staleCopy": "Copy awaiting an update",
      "previewSummaryHint": "This summary updates as you complete the fields and is saved with the request.",
      "summaryAddress": "Address",
      "summaryDate": "Delivery date",
      "summaryOrderNumber": "Order number",
      "summaryCustomer": "Customer",
      "title": "Assign customer and delivery address",
      "soon": "Coming soon",
      "hint": "Customer and address selection will be enabled when the Atlas master is available.",
      "customer": "Search customer (name, code or tax ID)",
      "taxId": "Tax ID",
      "customerHint": "Customers imported from Atlas.",
      "address": "Delivery / shipping address (numdir)",
      "addressHint": "Select a customer first to view their addresses.",
      "date": "Delivery date (installation)",
      "dateHint": "Expected delivery date.",
      "orderNumber": "Customer order number",
      "useProjectName": "Copy project name",
      "orderHint": "Customer purchase order number.",
      "summary": "Order summary",
      "summaryHint": "When this feature is enabled, the details below will update as you complete the form fields."
    },
    "atlasTestConfirmSubtitle": "This is the list produced by the Atlas Test reading trial.",
    "readingConnectionLabel": "Reading connection",
    "readingConnectionCurrent": "Current Atlas",
    "readingConnectionSimple": "Simplified reading (B)",
    "readingConnectionNotReady": "awaiting configuration",
    "readingConnectionHelp": "Choose a connection before the first analysis. Create separate requests to compare the same document.",
    "readingConnectionLocked": "This request keeps its reading connection throughout analysis and review.",
    "atlasTestNotice": "Reading test. You can review the results; sending quotes and orders is blocked.",
    "mandatoryDependencyConflict": "Some licences need review",
    "mandatoryDependencyConflictHint": "Your lines have been preserved. Review the licences and analyse again before continuing.",
    "mandatoryDependencyWarning": "Atlas found coverage information that needs review.",
    "confirmAllAndContinue": "Confirm all and continue",
    "continueRecognizedList": "Continue with this list",
    "continueRecognizedListHint": "The {{count}} items in the table will be kept, without adding other document fragments.",
    "previousIdentificationStep": "Back to the previous step",
    "identifyAction": "Identify",
    "identifyInTableHint": "Identify each product from its row. Atlas will guide you step by step.",
    "rackScopeHint": "Assign each component to its rack or leave it independent. Groups already defined by Atlas will not change.",
    "rackScopeChoose": "Choose a destination",
    "rackScopeIndependent": "Independent (no rack)",
    "rackScopeAssigned": "Assignment completed",
    "rackScopeUnavailable": "Atlas must complete the assignment data before you can continue.",
    "rackScopeLine": "Component",
    "commercialRejectionSummary": "View the outcome of the commercial review.",
    "partialRejectionText": "Validation is complete. These lines were rejected; the accepted products remain in the draft.",
    "validationCompleted": "Commercial validation completed",
    "validationCounts": "Accepted products: {{accepted}} · Rejected: {{rejected}}",
    "validationDraft": "Draft {{ref}} created in AdaQuote. The final quote and its prices are not available yet.",
    "lineRejectedCommercially": "Rejected by sales",
    "lineAcceptedCommercially": "Accepted by sales",
    "viewRejectionReasons": "View rejection reasons",
    "rejectionReasonsTitle": "Rejection reasons",
    "rejectionReasonsUnavailable": "No additional reasons have been received.",
    "commercialRejectionText": "The request was not approved during commercial review. You can see the reasons received below.",
    "rejectedLine": "Product {{number}}",
    "placeOrder": "Place order",
    "adaQuotePdfTitle": "Quote PDF · {{number}}",
    "loadingAdaQuotePdf": "Loading quote PDF…",
    "preparationTransition": "Opening your request status in {{count}} s.",
    "customerCodeBlockedHelp": "An administrator must complete the customer details. Reviewed products are preserved; resending stays blocked until resolved.",
    "checkCustomerCode": "Check details",
    "retrySubmission": "Resend to Atlas",
    "recoverReference": "Recover list",
    "recoveredReferenceHelp": "The list has a new number. Review the materials and confirm the submission again. The documents remain in the original request.",
    "viewOriginalRequest": "View original request",
    "customerCodeReady": "The customer code is now available. You can resend the request to Atlas.",
    "addFile": "Add file",
    "addMoreFiles": "Add other files",
    "addLine": "Add product",
    "addLineAfterReading": "Finish reviewing the document readings. Meanwhile, you can add products manually.",
    "addRow": "Add row",
    "analyzingHint": "You can close this page: the work continues on our side.",
    "analyzingStepIssuing": "Issuing the quote",
    "analyzingStepMatching": "Matching references",
    "analyzingStepPricing": "Applying prices",
    "analyzingStepReceived": "List received",
    "analyzingText": "We received your list and are pricing it. We will let you know as soon as the quote is ready.",
    "analyzingTitle": "Atlas is preparing your quote",
    "commercialReviewHint": "We will notify you when it is complete.",
    "commercialReviewStepAnalyzing": "Commercial review in progress",
    "commercialReviewStepChecking": "Checking products and terms",
    "commercialReviewStepReceived": "Received by the sales team",
    "commercialReviewStepValidating": "Validating the proposal",
    "commercialReviewText": "A sales representative is checking the proposal before sending it to you.",
    "commercialReviewTitle": "Your quote is under review",
    "backHome": "Back to home",
    "cancelDialogText": "Adaltra will stop working on it. You can reactivate it for 7 days; after that it and its documents will be permanently deleted.",
    "cancelDialogTitle": "Cancel this request?",
    "cancelProcess": "Cancel process",
    "cancelProcessEmptyText": "You will return to the home page. No request will be deleted because you have not saved any details yet.",
    "cancelProcessTitle": "Cancel this process?",
    "cancelRequest": "Cancel the request",
    "cancelledMessage": "Request cancelled",
    "cancelledCleanupNotice": "This request will be automatically deleted on {{date}}. You can reactivate it until then.",
    "cancelledCleanupList": "Will be automatically deleted on {{date}}",
    "deletePermanently": "Delete permanently",
    "permanentDeleteTitle": "Permanently delete this request?",
    "permanentDeleteText": "“{{name}}” and its documents will be deleted now. You will no longer be able to reactivate the request or undo this action.",
    "permanentlyDeleted": "Request permanently deleted",
    "changeMethod": "Change method",
    "chooseMethod": "Choose how to add the products. You'll be able to review and edit the list before requesting the quote.",
    "confirmCheck": "I've reviewed the list and confirm the details are correct.",
    "confirmBeforeSubmit": "Confirm that you have reviewed the list before sending the request.",
    "confirmNavigation": "Confirmation navigation",
    "confirmPendingFooter": "Confirm the list",
    "confirmReadyFooter": "Ready to send",
    "confirmSubtitle": "This is the list we'll send to Atlas to prepare your quote.",
    "confirmTitle": "Confirm your request",
    "estimatedPvpTitle": "RRP estimate",
    "estimatedSubtotal": "RRP excluding VAT",
    "estimatedVat": "VAT ({{rate}}%)",
    "estimatedTotal": "Total including VAT",
    "estimatedTotalPartial": "Partial total including VAT",
    "estimatedNoValuedLines": "Estimate pending: no items have been valued yet.",
    "estimatedPvpNote": "Approximate total calculated at list price, with no discounts applied.",
    "estimatedUnpricedIntro": "Items awaiting valuation:",
    "estimatedUnpricedProduct": "{{product}} — RRP: {{price}}",
    "estimatedUnpricedReasonProduct": "{{product}} — {{reasons}}",
    "estimatedQuantityPending": "Quantity pending",
    "estimatedCommercialBasisPending": "Purchase unit under sales review",
    "estimatedUnitPending": "Unit pending",
    "estimatedUnpricedPriceReason": "RRP: {{price}}",
    "estimatedPriceUnavailable": "Not available",
    "estimatedPartial_one": "{{count}} item still needs to be valued; the total shown is partial.",
    "estimatedPartial_other": "{{count}} items still need to be valued; the total shown is partial.",
    "continueDraft": "Continue",
    "dataSaved": "Project details updated",
    "desiredDate": "Preferred date",
    "detailDocuments": "Documents",
    "detailTimeline": "Tracking",
    "detailTitle": "Request details",
    "discardDraft": "Discard",
    "discardDraftConfirm": "Discard draft",
    "discardDraftText": "“{{name}}” will be deleted along with any photos and lines you added. This can't be undone.",
    "discardDraftTitle": "Discard this draft?",
    "draftDiscarded": "Draft discarded.",
    "draftLabel": "Unfinished request",
    "draftSaved": "Draft saved",
    "draftText": "You started it and never sent it.",
    "editData": "Edit the details",
    "editLine": "Edit line",
    "emptyText": "Your first bill of materials will appear here once you send it.",
    "emptyTitle": "No requests yet",
    "excludeLine": "Remove from the list",
    "excluded": "Excluded",
    "filesAdded": "Files added",
    "filesReady_one": "{{count}} file ready to process",
    "filesReady_other": "{{count}} files ready to process",
    "goToRequests": "View my requests",
    "humanNoteText": "This list includes the materials you reviewed and the suggestions you accepted.",
    "humanNoteTitle": "Atlas will also complete the solution",
    "inProgressProcessing": "Reading your list",
    "inProgressSubmitted": "Preparing your quote",
    "inProgressQuoteReview": "A sales representative is reviewing the quote",
    "includeLine": "Include in the quote",
    "itemsCount_one": "{{count}} item",
    "itemsCount_other": "{{count}} items",
    "leaveAndContinue": "Leave and continue later",
    "leaveDraft": "Exit",
    "materialsNavigation": "Product navigation",
    "addMaterialsFirst": "Add at least one product or file to continue",
    "processWithAtlas": "Analyse with Atlas",
    "linesDetected_one": "{{count}} line detected",
    "linesDetected_other": "{{count}} lines detected",
    "listSubtitle": "Check the status of everything you've sent.",
    "listTitle": "My requests",
    "paginationSummary": "{{from}}–{{to}} of {{total}} requests",
    "perPage": "Per page",
    "paginationAria": {
      "page": "Go to page {{page}}",
      "first": "Go to first page",
      "last": "Go to last page",
      "next": "Go to next page",
      "previous": "Go to previous page"
    },
    "location": "Installation site",
    "locationPlaceholder": "City or address",
    "manualEntry": "Enter manually",
    "manualEntryHint": "Add the products one by one",
    "manualHint": "Add our products, or enable Other brands to find equivalents row by row.",
    "externalManufacturer": "Ext. brand",
    "otherBrands": "Other brands",
    "externalCode": "External code/ref.",
    "equivalence": {
      "resolved": "Equivalent to {{product}}, according to Atlas.",
      "resolvedDetail": "{{source}} → {{product}}",
      "searching": "Searching Atlas equivalences…",
      "noCandidates": "No accredited candidates",
      "validated": "Validated",
      "proposal": "Proposal",
      "score": "Score {{score}}/100",
      "notFound": "Atlas has no accredited equivalent.",
      "unavailable": "The equivalence map could not be reached."
    },
    "fromCatalog": "From catalogue",
    "fromCatalogHint": "Catalogue item details cannot be changed here. To write it by hand, clear the code.",
    "catalogSearching": "Searching the catalogue…",
    "catalog": {
      "ambiguous": "Several items match. Pick one from the list.",
      "notFound": "Not in the catalogue. You can describe it by hand.",
      "unavailable": "We could not reach the catalogue. Fill the row in by hand."
    },
    "manualTitle": "Manual product list",
    "noCatalogResults": "No matches in the catalogue",
    "notes": "Notes",
    "notesPlaceholder": "Add anything else we should take into account…",
    "phaseFinishing": "Preparing the list for your review",
    "phaseValidatingResult": "Validating the complete list",
    "phaseIdentifying": "Identifying references and quantities",
    "phasePreparing": "Preparing the document",
    "phaseReading": "Recognising the text",
    "processingCompleted": "{{percent}}% complete",
    "processingErrorText": "Atlas couldn't complete the file analysis. You can retry with the saved files or add other files.",
    "processingErrorTitle": "We couldn't complete the analysis",
    "returnToPreviousReview": "Return to the previous list",
    "processingRemaining": "Atlas is still working",
    "processingSavedText": "You won't lose the project details.",
    "processingSavedTitle": "Your request has been saved",
    "processingSubtitle": "Progress follows Atlas updates, with gradual transitions between percentages. While waiting for an update, the last reported value is retained.",
    "processingGuardTitle": "Atlas must complete the list",
    "processingGuardText": "The review will open automatically once Atlas has identified and saved a valid list.",
    "processingQualityTitle": "Atlas is reviewing the reading",
    "processingQualityText": "The first reading is not good enough. We will keep waiting for a correct interpretation without showing faulty data.",
    "processingTitle": "Atlas is analysing the file",
    "queueGlobalLimit_one": "Queued · Global capacity: {{count}} concurrent analysis. This is not a per-customer limit.",
    "queueGlobalLimit_other": "Queued · Global capacity: {{count}} concurrent analyses. This is not a per-customer limit.",
    "queueNoUserLimit": "Queued for execution. Your user has no concurrent analysis limit.",
    "queueUserLimit": "Queued: each user can run {{count}} analyses simultaneously. This analysis will start automatically when one of yours finishes.",
    "queueHighDemand": "Demand is currently high. Your analysis is queued and will start when capacity becomes available (global limit: {{count}}).",
    "queuePosition": "Queue position: {{position}}",
    "processingUpdateErrorTitle": "We could not update the progress",
    "processingUpdateErrorText": "Atlas is still working. We will check again automatically.",
    "sendingPhotoTitle": "Sending the photo to Atlas",
    "sendingPhotoSubtitle": "Scanning is complete. The image is being delivered securely so it can be read.",
    "photoModeTitle": "List photo",
    "photoModeHint": "Fit all products in the frame and make sure the text is clearly readable.",
    "photoPreviewAlt": "Photo of the product list",
    "openCamera": "Open camera",
    "scanningPhoto": "Atlas is scanning the photo",
    "projectData": "Project details",
    "projectDataHint": "This information will help you identify the request later on.",
    "projectName": "Project name or reference",
    "projectNamePlaceholder": "e.g. North logistics warehouse refit",
    "reactivateRequest": "Reactivate request",
    "reanalyze": "Re-analyze",
    "reactivatedMessage": "Request reactivated",
    "readingText": "We are recognising the references and quantities in the document you uploaded. You will be able to review it as soon as it finishes.",
    "readingTitle": "Atlas is reading your list",
    "removeRow": "Remove row",
    "requestOptions": "Request options",
    "unidentifiedSummaryTitle": "Pending products",
    "unidentifiedSummaryCount": "{{count}} unidentified",
    "visualSummaryTitle": "Readings to confirm",
    "visualReadingSaved": "Reading confirmed",
    "visualIdentificationReady": "Readings confirmed. Select a pending product to answer Atlas’s questions.",
    "visualPreparingQuestions": "Reading saved. Atlas is preparing the product identification questions…",
    "visualSummaryCount": "{{count}} to confirm",
    "visualSummaryHint": "Confirm the text and quantity on every line. Atlas will then show the questions used to choose the products.",
    "identifyProduct": "Identify product",
    "includedComponentLabel": "Accessories included as standard",
    "atlasIncludedAccessory": "Included · Atlas",
    "atlasCandidateProducts": "Options found by Atlas",
    "atlasCandidateProductsHint": "Atlas interpreted the requirement and validated these options against the catalogue. Choose the correct one.",
    "atlasGuidedSelectionTitle": "Atlas helps you choose",
    "atlasIdentityTitle": "Review product identification",
    "atlasIdentityHint": "Atlas needs to clarify which product appears in the image, not choose its specifications.",
    "atlasIdentityField": "Code or reference",
    "atlasIdentityQuestion": "Check the code or reference in the image and correct it if needed. You can also use “Search the catalogue” to select the product.",
    "atlasIdentityPlaceholder": "Enter the code or reference and, if known, the brand",
    "atlasGuidedSelectionHint": "Select the features and we will show only the compatible product.",
    "atlasReplacementTitle": "Alternatives found by Atlas",
    "atlasReplacementHint": "This product is no longer available. Atlas has checked these options as possible replacements.",
    "discontinuedProduct": "Discontinued product",
    "discontinuedCommercialReview": "There is no confirmed direct replacement. A sales representative will review this line.",
    "discontinuedAlternativesAvailable": "Atlas has found compatible alternatives. Review and select the appropriate one.",
    "currentProductRange": "current product range",
    "atlasRackWaiting": "Atlas is calculating the required space and preparing compatible racks. You do not need to select the equipment again.",
    "atlasRackSizingTitle": "Space calculated by Atlas",
    "atlasRackEquipmentUnits": "Equipment: {{count}} U",
    "atlasRackReserveUnits": "Reserve: {{count}} U",
    "atlasRackVentilationUnits": "Ventilation: {{count}} U",
    "atlasRackMinimumUnits": "Minimum: {{count}} U",
    "atlasRackCompatibleSummary": "Showing {{count}} compatible racks of {{units}} U or more",
    "atlasSelectionStep": "Step {{step}}",
    "atlasPhoneLinesQuestion": "How many analogue telephone lines do you need to connect to the ONT?",
    "atlasPhoneLinesHint": "RJ11 connections for conventional telephones.",
    "atlasPhoneLines_one": "1 telephone line",
    "atlasPhoneLines_other": "{{count}} telephone lines",
    "atlasNoPhoneLines": "No telephone service",
    "atlasAnswerPlaceholder": "Enter your answer",
    "atlasAnaloguePhoneLines_one": "1 analogue telephone line",
    "atlasAnaloguePhoneLines_other": "{{count}} analogue telephone lines",
    "atlasAnaloguePhoneConnections": "analogue telephone connections",
    "atlasAnalogueTelephony": "analogue telephony",
    "atlasChooseFormat": "Which format do you need?",
    "atlasChooseUsers": "How many users should it support?",
    "atlasChoosePorts": "How many ports do you need?",
    "atlasChooseRackUnits": "What height do you need?",
    "atlasChoosePots": "How many telephone ports do you need?",
    "atlasUsersUpTo": "Up to {{count}} users",
    "atlasUsersRange": "From {{from}} to {{to}} users",
    "atlasPorts": "{{count}} ports",
    "atlasRackUnits": "{{count}} U",
    "atlasPots": "{{count}} POTS",
    "atlasCompatibleProduct_one": "Compatible product",
    "atlasCompatibleProduct_other": "Compatible products",
    "atlasProductCode": "Code {{code}}",
    "atlasSelectProduct": "Select",
    "atlasProductSelected": "Selected",
    "atlasSearchOtherProduct": "Search for another catalogue product",
    "atlasHideCatalogSearch": "Hide catalogue search",
    "atlasQuestionsTitle": "Information needed to choose correctly",
    "recognitionRecommendationsTitle": "Recommended by Atlas",
    "recognitionRecommendationsHint": "Complements Atlas considers necessary. You can decide on them in the next step.",
    "validateEquivalence": "Confirm equivalence",
    "equivalenceValidated": "Equivalence confirmed",
    "pendingProductsFooter": "{{count}} products still need identification",
    "pendingSuggestionsFooter_one": "1 product suggested by Atlas still to confirm",
    "pendingSuggestionsFooter_other": "{{count}} products suggested by Atlas still to confirm",
    "pendingEquivalencesFooter": "{{count}} equivalences still need confirmation",
    "commercialReviewFooter_one": "1 product will be sent for sales review",
    "commercialReviewFooter_other": "{{count}} products will be sent for sales review",
    "reviewReadyFooter": "Review complete",
    "reviewNavigation": "Review navigation",
    "reviewList": "List",
    "reviewSubtitle": "Check every line before requesting the quote.",
    "visualReviewTitle": "Confirm the image reading",
    "visualReviewConfirm": "Confirm reading",
    "visualEditReading": "Edit reading",
    "visualReviewConfirming": "Confirming…",
    "visualLiteralDescription": "Text read from the image",
    "visualReviewUncertainties": "Details to review",
    "visualTextOptions": "Readings proposed by Atlas",
    "visualQuantityOptions": "Quantities proposed by Atlas",
    "visualUnitOptions": "Units proposed by Atlas",
    "visualQuantityAlternatives": "Possible quantities: {{values}}",
    "visualUncertainTokens": "Uncertain text: {{values}}",
    "visualAlternativeReadings": "Other possible readings: {{values}}",
    "visualReviewReasonGeneric": "Atlas found differences between several readings of this line.",
    "visualReviewLineHint": "Confirm or correct the reading first. Atlas will then find the compatible options.",
    "atlasMoreQuestionsNeeded": "Atlas needs more details before showing compatible products.",
    "saveDraft": "Save draft",
    "searchCatalog": "Search the catalogue",
    "changeProduct": "Change product",
    "changeProductHint": "Search by code or reference and pick the product. Only the item changes: the pending quantity or unit is still confirmed here.",
    "saveProduct": "Save product",
    "searchCatalogHint": "Type a code, a reference or part of the description and pick the product: the fields fill themselves in.",
    "searchPlaceholder": "Search by reference or project",
    "secureText": "It will only be used to prepare and manage your quote.",
    "secureTitle": "Your information is safe",
    "sendDialogText": "Once sent you won't be able to edit the list. We'll notify you as soon as the quote is ready.",
    "sendDialogTitle": "Send the request to Atlas?",
    "sendRequest": "Send request",
    "sentEyebrow": "REQUEST SENT",
    "sentOn": "Sent on {{date}}",
    "sentRef": "Request reference",
    "sentRedirect": "Opening the details automatically in {{seconds}} s.",
    "sentRedirectLabel": "seconds until the details open automatically",
    "sentCountdown": "Atlas tracking will appear in {{seconds}} s.",
    "sentCountdownLabel": "Seconds until Atlas tracking appears",
    "sentText": "Atlas is preparing your quote. We'll let you know as soon as it's available.",
    "sentTitle": "We've received your request",
    "startProcessing": "Start processing",
    "stepConfirm": "Confirmation",
    "stepValuation": "Valuation",
    "stepData": "Details",
    "stepDocuments": "Documents",
    "stepOf": "Step {{current}} of {{total}}",
    "stepProcessing": "Processing",
    "stepReview": "Review",
    "stepRecommendations": "Recommendations",
    "recommendationsTitle": "Complete your solution",
    "recommendationsSubtitle": "Atlas reviewed the complete list for missing products, licences or services.",
    "recommendationsAnalyzing": "Atlas is checking the solution",
    "recommendationsAnalyzingHint": "It checks compatibility, capacity and included items to prevent duplicates.",
    "recommendationsFailed": "Atlas could not complete the recommendations.",
    "recommendationsNeedInfo": "Atlas needs one more detail",
    "recommendationsNeedInfoHint": "Your answers help select the correct product and quantity.",
    "analyzeAnswers": "Analyse answers",
    "analyze": "Analyse",
    "imagesReady_one": "1 image ready to analyse",
    "imagesReady_other": "{{count}} images ready to analyse",
    "imagesAdded": "Added images",
    "addPhoto": "Add photo",
    "recommendationsFound_one": "1 Atlas recommendation",
    "recommendationsFound_other": "{{count}} Atlas recommendations",
    "recommendationPending": "Pending confirmation",
    "recommendationImportance": {
      "required": "Required",
      "recommended": "Recommended",
      "optional": "Optional"
    },
    "recommendationCategory": {
      "prerequisite": "Technical requirement",
      "license": "Licence",
      "compatibility": "Compatibility",
      "accessory": "Accessory",
      "service": "Service"
    },
    "recommendedQuantity": "Suggested quantity: {{quantity}} {{unit}}",
    "addRecommendation": "Add",
    "replaceRecommendation": "Replace",
    "discardRecommendation": "Dismiss",
    "recommendationAdded": "Added",
    "recommendationReplaced": "Replaced",
    "replacementOf": "Replaces {{products}}",
    "addedByAtlas": "Added from an Atlas recommendation",
    "replacedByAtlas": "Replaced from an Atlas recommendation",
    "siteNumber": "Installation {{count}}",
    "recommendationDiscarded": "Dismissed",
    "notKnownYet": "I don't know yet",
    "noRecommendations": "Your solution is complete",
    "noRecommendationsHint": "Atlas found no additional products requiring review.",
    "recommendationsQuestionsFooter": "{{count}} answers required",
    "recommendationsPendingFooter": "{{count}} recommendations left to review",
    "recommendationsReadyFooter": "Recommendations reviewed",
    "takeAnotherPhoto": "Take another photo",
    "takePhoto": "Take a photo",
    "takePhotoHint": "Use your device camera",
    "titleData": "Tell us about the project",
    "titleMaterials": "Project documents",
    "uploadFile": "Upload a file or spreadsheet",
    "uploadFileHint": "PDF, Word, image, XLSX, XLS or CSV · Word is converted to PDF",
    "dragFilesHint": "You can also drag one or more files here to attach them.",
    "dropFilesHere": "Drop the files to attach them",
    "viewBudget": "View quote",
    "recognisedSoFar": "Recognised: {{count}}",
    "matchEquivalentFrom": "You asked for {{marca}}; we propose this EK equivalent",
    "match": {
      "direct": "Read as-is",
      "equivalent": "EK equivalent",
      "none": "Not identified",
      "not_needed": "Not needed",
      "noEquivalent": "No EK equivalent",
      "noEquivalentLong": "Identified as {{marca}}, but we have no EK equivalent"
    },
    "showDiscardedRows": "Show {{count}} rows set aside from the document",
    "hideDiscardedRows": "Hide the rows set aside",
    "discarded": {
      "headerRow": "Table header",
      "documentTitle": "Document title",
      "partidaRow": "Item duplicated by its breakdown",
      "outsideNumberedTable": "Content outside the materials table",
      "unreadableText": "Unreadable text",
      "otherScope": "Other item (labour, service or civil works)",
      "otherBrand": "Product that is not Ek/Openetics",
      "otherBrandMaker": "Other brand ({{brands}})",
      "otherBrandFamily": "Outside the Ek/Openetics catalogue ({{family}})",
      "documentText": "Document text (conditions, notes)"
    },
    "colProduct": "Product",
    "colReference": "Reference",
    "colDescription": "Description",
    "documentTechnicalWarning": "Note: {{differences}}. The identified product is retained.",
    "documentTechnicalDifference": "the document states “{{source}}” and the catalogue “{{catalog}}”",
    "colBrand": "Original brand",
    "colQuantity": "Quantity",
    "colUnitPrice": "Price",
    "colDiscount": "Disc.",
    "colLineSubtotal": "Subtotal",
    "colStatus": "Status",
    "convertedToEk": "Converted to EK",
    "groupResolved": "{{resolved}} of {{count}} products recognised",
    "groupExcluded": "{{count}} excluded",
    "groupsDetected": "{{count}} detected groups",
    "previewSelectCatalogProduct": "Select a product from the catalogue results to change the code or reference.",
    "atlasSuggestion": "Suggested by Atlas",
    "atlasSuggestionHint": "Alternative proposed by Atlas.",
    "reanalyzeDialogTitle": "Analyze the request again?",
    "reanalyzeDialogText": "Atlas will read the documents again with its current version. The new list will replace the current one and any changes you made during review will be lost.",
    "documentReading": {
      "pending": "Document reading pending review",
      "title": "Confirm or correct the reading",
      "help": "Choose an action for each row or notice. An empty quantity stays pending; confirming the text does not identify the product.",
      "fragment": "Pending fragment",
      "action": "Review action",
      "material": "Confirm or correct material",
      "ignore": "Discard row / acknowledge notice",
      "text": "Text read",
      "quantity": "Quantity (leave empty if unknown)",
      "unit": "Document unit",
      "close": "Close",
      "save": "Save review"
    },
    "recommendationsNavigation": "Suggestions navigation",
    "includedComponentReason": "added automatically with rack {{rack}}, at no cost.",
    "includedComponentReasonGeneric": "added automatically with the rack, at no cost.",
    "atlasSuggestionLabel": "Atlas alternative",
    "atlasSuggestionOtherBrand": "{{brand}} alternative (another brand)",
    "atlasSuggestionDifferences_one": "{{count}} difference",
    "atlasSuggestionDifferences_other": "{{count}} differences",
    "showDifferences": "Show differences",
    "hideDifferences": "Hide differences",
    "notInCatalogShort": "No equivalent in the catalogue",
    "originalBrandCaption": "In the document: {{value}}",
    "atlasRackNotCounted": "Not classified by Atlas for the rack, so not counted: {{items}}",
    "atlasRackUnresolved": "Unknown U height, not counted: {{items}}. The minimum only counts equipment with a known height.",
    "atlasRackExcluded": "Not taking rack space: {{items}}",
    "atlasRackWaitingUnits": "Atlas does not yet know the U height of some equipment in the list, so it cannot calculate the rack space.",
    "atlasRackWaitingUnitsNamed": "Atlas cannot calculate the rack space: it has no verified U height for {{items}}.",
    "atlasRackSizingTitleCurrent": "Space with the current list",
    "atlasRackStale": "The list has changed since Atlas calculated the space (minimum {{minimum}} U): it has been added up again with the current lines and the heights Atlas published.",
    "atlasRackStaleNoRecompute": "The list has changed since Atlas calculated the space, so these figures may be out of date: check the space before choosing the rack.",
    "atlasRackNotEvaluated": "Atlas has not assessed these lines for the rack (added or changed in the list), so they are not counted: {{items}}",
    "atlasRackPassive": "Passive rack items, not counted by the calculation: {{items}}",
    "atlasRackRecommendedNotInList": "Atlas also counted recommended equipment that is not in the list: {{items}}",
    "atlasRackStaleSummary": "With the current list you need a rack of {{units}} U or more.",
    "atlasRackStaleSummaryMinimum": "With the current list the minimum is {{units}} U.",
    "atlasRackCandidateTooSmall": "Less space than the current minimum ({{units}} U).",
    "showAtlasNote": "Show details",
    "hideAtlasNote": "Hide details",
    "showFullNote": "Show full note",
    "showLessNote": "Show less of the note",
    "includesStandardAccessories": "Includes {{items}} as standard, at no cost: it is added to the list automatically.",
    "rackCandidateIncludes": "Choosing this rack adds {{items}} to the list: it comes as standard, at no cost.",
    "pdfProcessing": {
      "label": "Document analysis with Atlas",
      "document": "Document",
      "reading": "Reading",
      "catalog": "Catalogue",
      "upload": "Preparing your document",
      "read": "Reading your document",
      "map": "Searching the catalogue",
      "done": "Reading complete",
      "waiting": "Waiting for Atlas",
      "lines": "Lines detected",
      "matched": "Products found",
      "files_one": "{{count}} file",
      "files_other": "{{count}} files",
      "sheet": "Sheet 1",
      "products": "Products",
      "portal": "Customer portal",
      "received": "Receiving data",
      "following": "Following the analysis",
      "sending": "Documents → Atlas",
      "returning": "Atlas → Portal",
      "exchange": {
        "prepare": "Preparing your documents",
        "send": "Atlas is reading your documents",
        "reason": "Atlas is processing the list",
        "match": "Atlas is assigning references",
        "receive": "Receiving the result in your portal",
        "waiting": "Waiting for Atlas",
        "checking": "Atlas is checking the result"
      },
      "atlas": {
        "prepare": "Receiving documents",
        "send": "Reading list",
        "reason": "Processing list",
        "match": "Assigning references",
        "receive": "List ready",
        "waiting": "Waiting",
        "checking": "Checking result"
      }
    },
    "copyReference": "Copy request reference",
    "copyReferenceFailed": "Could not copy the reference.",
    "validateAllAndContinue": "Validate all and continue",
    "validatingAll": "Validating…",
    "partidaOutsideCatalogTitle": "Products not from Ek/Openetics",
    "partidaOutsideCatalogHint_one": "{{count}} project product is not in the catalogue. Atlas proposes an equivalent alternative when there is one.",
    "partidaOutsideCatalogHint_other": "{{count}} project products are not in the catalogue. Atlas proposes an equivalent alternative when there is one.",
    "partidaUntitled": "Untitled item",
    "partidaMeasure": "Measurement {{measure}}",
    "partidaProducts_one": "{{count}} product",
    "partidaProducts_other": "{{count}} products",
    "atlasScene": {
      "label": "Atlas analysis",
      "document": "Document",
      "waiting": "Waiting for Atlas",
      "phase": {
        "upload": "Preparing your documents",
        "extract": "Atlas is splitting the document into lines",
        "enter": "The lines are going into Atlas",
        "master": "Atlas is looking up each line in the Master",
        "compose": "Atlas is building the list",
        "ready": "List ready",
        "handoff": "Opening your list"
      },
      "atlas": {
        "upload": "waiting",
        "extract": "reading",
        "enter": "receiving",
        "master": "checking the Master",
        "compose": "building",
        "ready": "ready",
        "handoff": "ready"
      },
      "master": {
        "searching": "Checking the Master",
        "done": "Building the list",
        "badge": "Master",
        "review": "Checking…"
      },
      "list": {
        "title": "List",
        "ready": "Your list",
        "chip": "Ready"
      },
      "steps": {
        "upload": "Upload",
        "extract": "Extraction",
        "enter": "Into Atlas",
        "master": "Master",
        "compose": "List",
        "portal": "Portal"
      },
      "voice": {
        "upload": "Receiving your document",
        "extract": "Reading every line",
        "enter": "Thinking",
        "master": "Searching the Master",
        "compose": "Building your list",
        "ready": "Done",
        "handoff": "Done",
        "waiting": "Waiting for my turn"
      }
    }
  },
  "requestStatus": {
    "in_progress": "In progress",
    "quote_rejected": "Rejected during commercial review",
    "submission_blocked": "Submission blocked",
    "draft": "Draft",
    "processing": "Reading the list",
    "review": "Awaiting your review",
    "submitted": "Preparing quote",
    "quote_review": "Quote under review",
    "quote_validated": "Quote validated · awaiting acceptance",
    "quote_partially_validated": "Quote partially validated · awaiting review",
    "quote_won": "Quote won",
    "quote_lost": "Quote lost",
    "quoted": "Quote available",
    "cancelled": "Cancelled",
    "failed": "Reading error",
    "ordering": "Converting to order",
    "ordered": "Order created",
    "order_blocked": "Order not confirmed"
  },
  "support": {
    "title": "Support",
    "subtitle": "Tell us what you need and we'll reply by email.",
    "topic": "Subject",
    "topicRequest": "Question about a request",
    "topicBudget": "Question about a quote",
    "topicAccount": "Problem with my account",
    "topicOther": "Something else",
    "relatedRef": "Related reference",
    "message": "Message",
    "messagePlaceholder": "Describe your query in as much detail as possible…",
    "send": "Send enquiry",
    "sentTitle": "We've received your enquiry",
    "sentText": "We'll reply to your account email within 24 working hours.",
    "received": "Enquiry sent"
  },
  "theme": {
    "label": "Theme",
    "light": "Light",
    "dark": "Dark",
    "system": "Match system"
  },
  "unitReview": {
    "processing": "Atlas is confirming the unit…",
    "pending": "Unit awaiting confirmation",
    "line": "Component",
    "sourceGroup": "Source item",
    "confirm": "Confirm unit",
    "change": "Correct unit",
    "title": "Confirm unit of measure",
    "original": "Original unit: {{unit}}",
    "source": "Page/sheet {{page}} · row {{row}} · code {{code}}",
    "quantityUnchanged": "Only this line's unit is confirmed. Quantity, other lines and source grouping stay unchanged.",
    "choose": "Choose an accepted unit",
    "separateAction": "Confirm or correct the unit using the dedicated row action; selecting a product does not confirm it.",
    "blocked": "Confirm pending units on material lines before continuing.",
    "returnToReview": "Review units",
    "orderBlocked": "The order cannot be accepted while units are pending. Review the linked request.",
    "notSynchronized": "The unit was not applied: Atlas did not confirm the change and the line is still pending. Please confirm it again."
  },
  "units": {
    "ud": "pcs",
    "m": "m",
    "kg": "kg",
    "h": "h",
    "box": "box"
  },
  "atlasPending": {
    "title": "Pending for Atlas",
    "help": "Select a product to answer Atlas and complete its identification.",
    "fullDescription": "Full description"
  },
  "installation": {
    "comingSoon": "Coming soon",
    "describeTitle": "Describe your installation to Atlas",
    "describeHint": "Atlas prepares the materials based on what you need",
    "steps": {
      "description": "Your installation",
      "details": "Details",
      "materials": "Materials",
      "suggestions": "Suggestions",
      "technicalReview": "Technical review",
      "confirmation": "Confirmation"
    },
    "phases": {
      "revision": "Materials review",
      "confirmar": "Quote confirmation"
    },
    "newRequestNotice": "This request already contains materials or documents. When you send the description, we will create another request with the same project details and keep this one.",
    "restartNotice": "If you send the description again, Atlas will start a new analysis and ask you for the necessary details again.",
    "tellUs": "Tell us what you need",
    "descriptionLabel": "Your installation",
    "descriptionHelp": "Describe the goal, the dimensions, the existing equipment and any requirement we should take into account.",
    "useExample": "Use an example description",
    "example": "I want to improve the Wi-Fi in a single-floor office with four rooms. I already have a router and network cabling. I need access points for about twenty users and want to know what other equipment is required.",
    "proposalTitle": "Your materials proposal",
    "technicalPendingTitle": "Pending technical checks",
    "atlasUpdatePendingTitle": "Waiting for an Atlas update",
    "resolveHint": "You don't need to answer again. Atlas has to complete the selection with the available documentation and alternatives.",
    "noMoreQuestions": "Atlas has no more questions for you right now. Your request is saved and you can resume it from Home.",
    "previewNotice_one": "This material is a preview. You can confirm, edit or remove it once Atlas finishes its checks.",
    "previewNotice_other": "These {{count}} materials are a preview. You can confirm, edit or remove each one once Atlas finishes its checks.",
    "correctDescription": "Correct the description",
    "blockersNotice": "These checks are still pending before a proposal ready to confirm can be shown.",
    "atlasDetails": "See Atlas details",
    "noProposalYet": "No proposal is available yet. Check the status to see if there is any news.",
    "clarifyTitle": "Let's clarify your installation",
    "clarifyHint": "Tap each topic to answer step by step. Then we will send your answers to Atlas.",
    "retryableFailure": "Atlas could not finish the analysis because of a temporary interruption. Your answers are saved. You can retry without starting over.",
    "failure": "Atlas could not complete the proposal. You can review the description and try again.",
    "plannerUnavailableTitle": "Atlas could not plan the installation right now",
    "plannerUnavailableText": "Your description has been kept. You can try again in a few minutes or fill in the product list yourself; Atlas will identify the products in the catalogue when you continue.",
    "plannerRetry": "Try again",
    "awaitingConfirmation": "Waiting for your confirmation",
    "whyComponents": "Why these components",
    "youDecideTitle": "You decide what goes into the quote",
    "youDecideText": "First we will settle the missing details. Then you can review the materials, understand why they were chosen and add optional improvements.",
    "yourDescription": "Your description",
    "atlasObservations": "Atlas notes",
    "referenceFiles": "Reference files",
    "optionalTag": "(optional)",
    "confirmedCount": "{{confirmed}} of {{total}} materials confirmed.",
    "provisionalCount_one": "1 provisional material · Waiting for Atlas",
    "provisionalCount_other": "{{count}} provisional materials · Waiting for Atlas",
    "detailsCompleted": "{{done}} of {{total}} details completed",
    "retrying": "Retrying analysis…",
    "resolving": "Reviewing with Atlas…",
    "checking": "Checking…",
    "preparingAction": "Preparing proposal…",
    "retry": "Retry analysis",
    "resolve": "Resolve with Atlas",
    "checkStatus": "Check status",
    "sendDescription": "Send proposal",
    "reviewDescription": "Review description",
    "sendAnswers": "Send answers",
    "reviewTopic": "Review: {{topic}}",
    "clarifyTopic": "Clarify: {{topic}}",
    "answersSaved": "Answers saved. You can review them.",
    "stepsToClarify_one": "1 step to clarify it",
    "stepsToClarify_other": "{{count}} steps to clarify it",
    "tapToAnswer": "Tap to answer",
    "completed": "Completed",
    "pending": "Pending",
    "clarifyDetail": "Clarify this detail",
    "closeKeepAnswers": "Close and keep answers",
    "previous": "Previous",
    "backToQuestions": "Back to the questions",
    "next": "Next",
    "saveAnswers": "Save answers",
    "selectOption": "Select an option",
    "quantity": "Quantity",
    "yourAnswer": "Your answer",
    "optionalAnswer": "Optional. You can continue without answering.",
    "whyAtlasAsks": "Why does Atlas ask this?",
    "preparingTitle": "Atlas is preparing your installation",
    "preparingText": "We are reviewing your description and the catalogue products.",
    "preparingProgress": "Atlas is preparing the proposal",
    "preparingLeave": "You can leave and come back to this request to continue.",
    "columns": {
      "code": "Code",
      "reference": "Reference",
      "name": "Short description",
      "quantity": "Quantity",
      "actions": "Actions"
    },
    "proposalTableLabel": "Materials proposed by Atlas",
    "allRemoved": "You have removed all the materials. Go back to your description to prepare another proposal.",
    "confirmItem": "Confirm {{name}}",
    "editItem": "Edit {{name}}",
    "itemConfirmed": "{{name}} confirmed",
    "remove": "Remove",
    "removeItem": "Remove {{name}}",
    "userCatalogReason": "Product you selected in the catalogue. Its suitability for the installation is pending review.",
    "referencesHint": "Add plans, photos or documents to help Atlas understand the installation.",
    "removeFile": "Remove file",
    "savingReferences": "Saving reference files",
    "referencesLocked": "To change these files, restart the proposal analysis.",
    "changeFiles": "Change files",
    "savingFiles": "Saving files…",
    "attachFiles": "Attach files",
    "attachReferences": "Attach reference files",
    "referencesLimits": "PDF, JPG, PNG or WebP. Up to 5 files, 10 MB per file and 20 MB in total.",
    "changeReferencesTitle": "Change reference files",
    "changeReferencesText": "The description and the files will be kept. After changing them you will have to send the proposal again; Atlas will analyse it again and the answers from the previous analysis will not be used.",
    "verificationTitle": "Atlas technical review",
    "verified": "Atlas has verified this list. You can now review the summary and confirm the request.",
    "verifying": "Atlas is reviewing the products, the quantities and their compatibility…",
    "verificationQuestions": "Atlas needs these details to validate your installation",
    "verificationBlocked": "The review does not allow confirmation yet. Check Atlas's notes and correct the list or complete the details.",
    "verificationIntro": "Before you confirm, Atlas will check the installation with the list you reviewed and the selected improvements.",
    "reviewMaterials": "Review materials",
    "listVerified": "List verified",
    "verificationRunning": "Review in progress",
    "verificationPending": "Pending review",
    "verifyWithAtlas": "Review with Atlas",
    "suggestionsTitle": "Complete your installation",
    "suggestionsHint": "Review Atlas's suggestions and decide which ones you want to add to your proposal.",
    "backToProposal": "Back to the proposal",
    "observations": {
      "analysisNeedsInput": "Complete the details Atlas needs to review the installation.",
      "lineRevision": "Review the materials: Atlas has detected required components or incompatibilities still to be resolved.",
      "mandatoryDependencies": "Components required for the installation to work are missing. Review Atlas's suggestions.",
      "catalogChanged": "The catalogue has changed. Review the products before validating the installation again.",
      "catalogMismatch": "Atlas must correct the references or units that do not match the catalogue before showing the materials.",
      "pending": "An Atlas check is pending.",
      "reviewNeeded": "Atlas needs you to review the installation before continuing."
    },
    "plannerReadAsList": "Let Atlas read it as a list",
    "typedTextPlannerNotice": "Atlas read your text and it describes an installation, not a product list: it prepares the installation proposal from this same description.",
    "materialListBlockedTitle": "We could not read the list in this request",
    "materialListBlockedText": "Your list has been kept. This request changed while you were writing it and cannot take the list right now. You can have Atlas read it in a new request with the same project details or fill in the products by hand.",
    "materialListNewRequest": "Read it in a new request"
  },
  "adaltra": {
    "portal": "Customer portal",
    "workspace": "Your workspace",
    "helpTitle": "Here to help",
    "helpBody": "We can help with your requests and quotes.",
    "helpAction": "Contact support",
    "skip": "Skip to content",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "navigation": "Main navigation",
    "activity": "Your portal",
    "account": "Your account",
    "search": "Search requests",
    "searchHint": "Search requests by name or reference…",
    "noResults": "No sections found",
    "welcome": "Welcome to your portal",
    "client": "Customer",
    "team": "ADALTRA team",
    "navigate": "Find a section",
    "navigateHint": "Go to a section…",
    "searchSubmit": "Search requests",
    "expandSidebar": "Expand menu",
    "collapseSidebar": "Collapse menu"
  },
  "pdfLab": {
    "nav": "PDF reader",
    "title": "Read your document before sending it",
    "eyebrow": "Documents / Atlas",
    "subtitle": "Extract the text, review the products and prepare only what Atlas needs.",
    "drop": "Drop your documents here",
    "formats": "PDF, JPG and PNG · Up to 15 MB per file and 60 pages in total",
    "select": "Select documents",
    "forceOcr": "Use OCR on every page",
    "readAgain": "Read again",
    "progressOcr": "Reading page {{page}} with OCR…",
    "progressText": "Extracting text from page {{page}}…",
    "tooLarge": "The file is empty or exceeds 15 MB.",
    "tooManyPages": "The documents exceed 60 pages. Split the file.",
    "tooManyPixels": "The page is too large to process in the browser.",
    "unsupported": "Select a valid PDF, JPG or PNG.",
    "unreadable": "The document could not be read. Check if it is damaged or password protected.",
    "pageCount": "{{count}} pages",
    "lineCount": "{{count}} products read",
    "ocrCount": "{{count}} OCR pages",
    "reviewHint": "Review references, descriptions, quantities and units before sending. The original stays on your device. No PDF is sent to Atlas.",
    "products": "Document products",
    "identify": "Check catalogue",
    "identifying": "Checking catalogue…",
    "include": "Include",
    "reference": "Reference",
    "description": "Description",
    "quantity": "Quantity",
    "unit": "Unit",
    "brand": "Brand",
    "status": "Identification",
    "exact": "Exact match",
    "approximate": "Candidates to review",
    "unmatched": "No match",
    "unavailable": "Catalogue unavailable",
    "pending": "Not checked",
    "pages": "Original text by page",
    "page": "Page {{page}}",
    "embedded": "PDF text",
    "sourceText": "Original text",
    "onlyLines": "Prepare only the selected product lines",
    "preparedText": "Text to send to Atlas",
    "textCount": "{{count}} characters · Content is never truncated automatically.",
    "download": "Download text",
    "send": "Send reviewed text to Atlas",
    "sending": "Sending text…",
    "textUnsupported": "This Atlas connection does not support text yet. You can download it. The PDF will not be sent as a fallback.",
    "textTooLong": "The text exceeds the limits of this Atlas connection. Review the selection or prepare separate requests; truncated text will not be sent.",
    "sendError": "The text could not be sent. Check the request status before trying again.",
    "newDraftRequired": "To use PDF pre-reading, open a new request with no documents or products. The current request is preserved.",
    "pageCount_one": "1 page",
    "lineCount_one": "1 product read",
    "ocrCount_one": "1 OCR page",
    "editLine": "Correct a product",
    "reviewTitle": "Review the products read",
    "reviewSubtitle": "Check quantities and references. Correct any product before continuing.",
    "uploadTitle": "Add your documents",
    "uploadSubtitle": "We will read the text and scanned pages before sending them to Atlas.",
    "changeMethod": "Change method",
    "textCountShort": "{{count}} characters"
  },
  "preferences": {
    "title": "Preferences",
    "subtitle": "Choose which notifications to receive and through which channel.",
    "notifications": "Notification types",
    "description": "Your preferences are saved to your account and apply across your devices.",
    "deliveryHint": "Email and push depend on the channels enabled by your company. To receive push, also enable notifications on this device. Account access and security emails remain enabled.",
    "saved": "Preferences saved.",
    "channels": {
      "email": "Email",
      "portal": "Portal",
      "push": "Push"
    },
    "categories": {
      "requests": {
        "title": "Requests",
        "description": "Submission, receipt and reading completion."
      },
      "budgets": {
        "title": "Quotes",
        "description": "Availability, reviews and status changes."
      },
      "reminders": {
        "title": "Reminders",
        "description": "Reminders to review pending quotes."
      },
      "incidents": {
        "title": "Issues",
        "description": "Errors reading documents or preparing quotes."
      },
      "updates": {
        "title": "Updates and other notifications",
        "description": "General communications and internal notifications."
      }
    }
  },
  "twoFactor": {
    "title": "Two-step verification",
    "body": "We have sent a 6-digit code to",
    "codeLabel": "Verification code",
    "submit": "Verify and sign in",
    "notReceived": "Didn’t receive it?",
    "resend": "Resend",
    "resendIn": "Resend ({{time}})",
    "expired": "Your verification session has expired. Sign in again."
  },
  "adaltraProfile": {
    "roles": {
      "client": "Customer",
      "commercial": "Sales",
      "manager": "Manager",
      "admin": "Administrator",
      "orders": "Orders"
    },
    "protection": "Your account, protected",
    "protectionHint": "Two-step verification by email. We verify your sign-in with a single-use code.",
    "devicesHint": "Verified browsers can be remembered for 30 days. You can remove trust from all of them.",
    "forgetDevices": "Forget devices",
    "devicesRevoked": "Your trusted devices have been forgotten.",
    "passwordHint": "Update your password to protect your account."
  },
  "stock": {
    "customerOrdersTitle": "Customer orders awaiting delivery",
    "reportedDate": "Reported date: {{value}}",
    "customerOrdersCount": "Reported order count: {{value}}",
    "customerOrdersUnavailable": "Order breakdown unavailable",
    "customerOrdersEmpty": "The received list contains no pending orders.",
    "orderCustomer": "Customer",
    "customerOrderNumber": "Customer order no.",
    "orderDate": "Order date",
    "deliveryDate": "Delivery date",
    "orderQuantity": "Quantity",
    "explanation": "View received explanation",
    "ordersAndCommitments": "Orders and commitments",
    "pendingCustomers": "Pending customer deliveries",
    "supplierOrders": "On order from suppliers",
    "totalCommitted": "Total committed",
    "remainingAfterRequest": "Remaining after operation",
    "warehouses": "Physical stock by warehouse",
    "warehouse": "Warehouse",
    "warehouseUnavailable": "Warehouse breakdown unavailable",
    "supplyArrivals": "Expected supplier arrivals",
    "purchaseOrdersCount": "Purchase orders: {{value}}",
    "expectedDate": "Expected date",
    "purchaseOrder": "Order",
    "noArrivalDate": "No expected date",
    "nextArrival": "Next arrival: {{value}}",
    "noIndicator": "No indicator",
    "column": "Stock",
    "available": "Available: {{value}}",
    "unknown": "Unknown",
    "not_queried": "Stock not checked",
    "unavailable": "Stock unavailable",
    "not_applicable": "Not applicable",
    "physical": "Physical",
    "virtual": "Virtual",
    "committed": "Total committed",
    "checkedAt": "Checked (Spain time): {{value}}",
    "requested": "Query context: {{value}} {{unit}}",
    "notComparable": "Comparison with the requested quantity is not verified.",
    "reason": "Reason: {{value}}",
    "informational": "For information only. This does not reserve goods or guarantee supply.",
    "details": "View stock details. {{summary}}",
    "green": "Atlas green indicator",
    "amber": "Atlas amber indicator",
    "red": "Atlas red indicator",
    "article": "Item",
    "requestedColumn": "Requested quantity",
    "physicalVirtual": "Physical / virtual stock",
    "committedColumn": "Total committed",
    "availableColumn": "Effective available",
    "indicatorColumn": "Indicator",
    "dialogTitle": "Product stock",
    "minimumPurchase": "Minimum purchase quantity: {{value}}",
    "minimumPurchasePackaging": "Minimum purchase quantity: {{value}} (packaging {{packaging}})",
    "minimumPurchaseShort": "Min. {{value}}",
    "metric": "Metric",
    "checking": "Checking stock…",
    "multipleOrders": "Multiple orders: {{value}}",
    "yes": "Yes",
    "no": "No",
    "level": "Level: {{value}}",
    "sharedProductTotal": "The indicator and remaining stock refer to this product’s total in the list, not an allocation per line.",
    "stale": "This stock check has expired. Refresh it to obtain current data.",
    "purchaseBasisUnknown": "The product purchase unit or basis could not be verified.",
    "identityUnverified": "The product could not be verified in the catalogue.",
    "sourceUnavailable": "The stock service is currently unavailable.",
    "reasonUnknown": "Atlas could not verify current stock data."
  },
  "stockSearch": {
    "productImage": "Image of {{reference}}",
    "imageUnavailable": "Image unavailable",
    "hint": "Search requests or stock by code / reference…",
    "label": "Search requests or product stock",
    "requests": "Search requests with this text",
    "not_found": "Enter a complete product code or reference to check stock.",
    "ambiguous": "This reference matches several products. Enter the complete product code.",
    "unavailable": "The product could not be checked. Please try again."
  },
  "closedOrder": {
    "confirmTitle": "Confirm order",
    "confirmSubtitle": "Review the closed order before sending it to Atlas. No recommendations will be added and quantities will stay unchanged.",
    "stockNotice": "Atlas reports stock limitations for some products. Open their stock indicators for details; you can send the order without changing products or quantities. Stock is informational and does not reserve materials.",
    "send": "Send to Atlas",
    "dialogTitle": "Send this order to Atlas?",
    "dialogText": "Your reviewed list will be sent without adding recommendations. Check the products and quantities before confirming.",
    "reviewSubtitle": "Check the order’s products and quantities before sending it to Atlas.",
    "reviewedNote": "This order contains only the products and quantities in your reviewed list."
  },
  "productThumbnail": {
    "image": "Image of {{reference}}",
    "unavailable": "Product image unavailable"
  },
  "customerOrder": {
    "action": "Won and convert to order",
    "dialogTitle": "Mark as won and convert to order?",
    "dialogText": "Atlas will send {{ref}} to Ada-quote, mark the quote as WON and convert it into an ORDER with the customer, address, delivery date and order number from step 1. This creates a real order.",
    "retry": "Retry",
    "confirmedDetail": "Order {{order}} · Quote {{quote}}",
    "providerError": "Ada-quote answered: {{code}}",
    "state": {
      "requested": "Preparing the order…",
      "submission_failed": "The request could not be sent",
      "pending_creation": "Creating the quote in Ada-quote…",
      "sending": "Converting to order…",
      "confirmed": "Quote won and converted to order",
      "rejected": "Ada-quote rejected the order",
      "uncertain": "The order could not be confirmed"
    },
    "refresh": "Refresh status",
    "processingTitle": "Converting to order",
    "processingText": "Atlas is marking the quote as won and creating the order in Ada-quote.",
    "processingHint": "You can close this page: the order keeps going.",
    "step": {
      "sending": "Sending the request to Atlas",
      "quote": "Preparing the quote in Ada-quote",
      "won": "Marking the quote as won",
      "order": "Creating the order",
      "pack": "Preparing the order",
      "send": "Sending the order to MTR",
      "wait": "Waiting for MTR to confirm…"
    },
    "orderLabel": "Order",
    "quoteLabel": "Quote",
    "totalLabel": "Total",
    "deliveryLabel": "Delivery",
    "customerOrderNumberLabel": "Customer PO",
    "stamp": "WON"
  },
  "maintenance": {
    "banner": "Atlas is under maintenance. You can create requests and upload documents: when you press “Analyse” they will be queued and processed automatically afterwards.",
    "until": "Expected until {{time}}.",
    "title": "Maintenance mode",
    "active": "Active",
    "inactive": "Off",
    "description": "While active, “Analyse” queues requests and Atlas starts no new readings; readings already in progress finish. When it is turned off, the queue is sent automatically in order. It turns itself off after 2 hours.",
    "since": "Active since {{time}}",
    "estimate": "expected until {{time}}",
    "expires": "turns off automatically at {{time}}",
    "message": "Message for users (optional)",
    "minutes": "Estimated duration (min)",
    "processing_one": "{{count}} reading in progress",
    "processing_other": "{{count}} readings in progress",
    "queued_one": "{{count}} request queued",
    "queued_other": "{{count}} requests queued",
    "turnOn": "Turn on maintenance",
    "turnOff": "Turn off and send the queue",
    "queuedTitle": "Request queued",
    "queuedText": "Atlas is under maintenance. Your request is saved in the queue and will be sent to Atlas automatically as soon as it ends; we will notify you when processing starts. You can close this screen.",
    "queuedHome": "Go to home"
  }
}
